// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.container {
  padding: 1rem;
  display: flex;
  flex-direction: column;
}
.container .header h2 {
  font-size: 1.2rem;
}
.container .header .row {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.container .header .row .mat-mdc-form-field {
  width: 80%;
}
.container .header .row button {
  padding: 0.5rem 2rem;
  background-color: rgb(174, 15, 10);
  color: #fff;
  border: none;
  border-radius: 1rem;
}
.container .entitie-filters {
  width: 100%;
}
.container .entitie-filters .mat-mdc-form-field {
  width: 100%;
}
.container table {
  min-height: 20vh;
}
.container .buttons {
  margin-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  justify-content: center;
}
@media (max-width: 767px) {
  .container .buttons {
    flex-direction: column;
  }
}
.container .buttons button:first-of-type {
  margin-right: 10px;
}

.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.field-width {
  width: 70%;
}
@media (max-width: 767px) {
  .field-width {
    width: 90%;
    margin-left: 15px;
  }
}

.login-container {
  display: flex;
}
@media (max-width: 767px) {
  .login-container {
    flex-direction: column;
  }
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 92vh;
  width: 100%;
}

.bold-font {
  font-weight: bold;
  font-size: 1rem;
}

.login-form {
  width: 100%;
  margin-bottom: 10rem;
  padding: 0 8rem;
}
@media (max-width: 767px) {
  .login-form {
    height: 92vh;
  }
}
.login-form form {
  height: inherit;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767px) {
  .login-form form {
    height: 92vh;
  }
}
.login-form .fields {
  width: 100%;
  flex: 1;
  min-height: 55vh;
}
@media (max-width: 767px) {
  .login-form .fields {
    width: 100%;
  }
}
.login-form .line {
  display: flex;
  justify-content: center;
}
.login-form .line hr {
  border: none;
  height: 2px;
  background-color: #bdbcbc;
  width: 80%;
  border-radius: 5px;
}
@media (max-width: 767px) {
  .login-form .line hr {
    width: 100%;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  margin-top: 2.5rem;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 100%;
    height: 45px;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  margin-top: 2.5rem;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2)[disabled] {
  background: rgb(189, 188, 188);
}
.login-form .name-form-field {
  text-align: center;
  color: rgb(60, 60, 59);
}
.login-form .invalid {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
}
@media (max-width: 767px) {
  .login-form .invalid {
    margin-left: 5px;
  }
}
.login-form .invalid .icon-error {
  padding-left: 10px;
  padding-right: 8px;
}
.login-form .login-field-prefix {
  color: rgb(60, 60, 59);
}
.login-form .email-form-field {
  text-align: center;
  color: rgb(60, 60, 59);
}
.login-form .email-field-prefix {
  color: rgb(60, 60, 59);
}
.login-form .email-field-prefix-invalid {
  padding-top: 7px;
  padding-bottom: 15px;
  color: rgb(60, 60, 59);
}
.login-form h6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-form h6 mat-icon {
  cursor: pointer;
}
@media (max-width: 767px) {
  .login-form h6 {
    margin-top: 2rem;
    margin-bottom: 2rem;
    margin-left: 15px;
  }
}
@media (max-width: 767px) {
  .login-form {
    margin-bottom: 1rem;
    padding: 0 1rem;
    width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .login-form {
    margin-bottom: 3rem;
    padding: 0 2rem;
  }
}
@media (min-width: 1025px) and (max-width: 1366px) {
  .login-form {
    margin-bottom: 4rem;
    padding: 0 4rem;
  }
}
@media (min-width: 1367px) {
  .login-form {
    margin-bottom: 5rem;
    padding: 0 4rem;
  }
}

.mat-expansion-panel-header-title {
  font-size: 1rem;
}

.panel-with-border .mat-expansion-panel-header {
  border-bottom: 1px solid black;
  /* Estilo da borda quando o painel está aberto */
}

.panel-with-border .mat-expansion-panel-header.mat-expanded {
  border-bottom: none;
  /* Remove a borda inferior quando o painel está aberto */
}

.panel-with-border.mat-expansion-panel {
  border-bottom: 1px solid black;
  /* Estilo da borda do painel quando fechado */
}

.mat-expansion-panel {
  box-shadow: none !important;
  background-color: transparent;
  border-radius: 0;
}

.mat-mdc-select-arrow-wrapper {
  display: none !important;
}

/* Estilizar o novo ícone */
.custom-select-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 24px;
  /* Ajuste o tamanho do ícone conforme necessário */
}

.form-group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-group .mat-mdc-form-field {
  width: 45%;
}
.form-group .first-input {
  width: 100%;
}
.form-group .bank-form-field {
  width: 70%;
}
.form-group p {
  margin-top: 0px;
  font-size: 1.1rem;
}

.btn-primary {
  margin: 0rem 1rem;
}

.btn-exclude {
  border: 2px solid rgb(112, 111, 111) !important;
  background-color: transparent !important;
  color: rgb(112, 111, 111) !important;
  font-weight: bold !important;
}

.btn-submit {
  background-color: rgb(174, 15, 10) !important;
  color: #fff !important;
  border: 2px solid rgb(174, 15, 10) !important;
}

.disabled-button {
  background-color: rgb(112, 111, 111) !important;
  color: white;
  border: 2px solid rgb(112, 111, 111) !important;
  cursor: not-allowed;
}

.btn-back {
  background-color: transparent !important;
  color: rgb(174, 15, 10) !important;
  border: 2px solid rgb(174, 15, 10) !important;
}

@media (max-width: 500px) {
  .form-group {
    display: flex;
    flex-direction: column;
  }
  .form-group .mat-mdc-form-field {
    width: 100%;
  }
  .fields {
    flex: 1;
    min-height: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/entities/vincular-concessionaria/vincular-concessionaria.component.scss","webpack://./node_modules/@angular/material/core/ripple/_ripple.scss","webpack://./node_modules/@angular/cdk/a11y/_index.scss","webpack://./node_modules/@angular/cdk/overlay/_index.scss","webpack://./node_modules/@angular/cdk/text-field/_index.scss","webpack://./node_modules/@angular/material/core/focus-indicators/_private.scss","webpack://./node_modules/@angular/material/core/style/_layout-common.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/typography.scss","webpack://./src/theme/spacing.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACKd;EACE,gBAAA;EAIA,kBAAA;ADAJ;ACOI;EACE,wBAAA;ADLN;;ACSE;EACE,iBAAA;ADNJ;;ACSE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADVJ;AEyBI;EDXE,aAAA;ADXN;;AEzBE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AFgBJ;AEdI;EACE,UAAA;EACA,QAAA;AFgBN;;AGhCE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AHgCJ;;AG5BE;EACE,eAAA;EACA,aA3BwB;AH0D5B;AG7BI;EAGE,aAAA;AH6BN;;AGrBE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AHkElB;;AGpBE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AHkBJ;;AGfE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AHgBJ;AGdI;EACE,UAAA;AHgBN;AGXM;EAGE,YAAA;AHWR;;AGNE;EACE,+BAtFqB;AH+FzB;;AGNE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AHQJ;AGFI;EACE,UAAA;EACA,mBAAA;AHIN;;AGAE;EACE,gBAAA;AHGJ;;AGEE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AHRJ;;AGYE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AHjBJ;;AIhIE;EACE,YAAA;AJmIJ;;AI7HE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJiIJ;;AIxHE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJ4HJ;;AIlHE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJmHJ;;AIhHE;EAEE,6CAAA;AJkHJ;;AKjJE;EACE,kBAAA;ALoJJ;AKlJI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;AL6IN;AKrII;EACE,WAAA;ALuIN;;AE5FM;EG7BA,oCAAA;AL6HN;;AKxKE;EACE,kBAAA;AL2KJ;AKzKI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALoKN;AK5JI;EACE,WAAA;AL8JN;;AEnHM;EG7BA,wCAAA;ALoJN;;AO7MA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARoNF;;AQjNA;;;;;;EAME,qCAAA;EACA,gBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,gBAAA;EACA,eAAA;ARoNF;;AOtRA;;;;;CAAA;AEeE;EACE,YAAA;ATgRJ;;AS9QE;EACE,gBAAA;ATiRJ;;AS/QE;EACE,kBAAA;ATkRJ;;AShRE;EACE,mBAAA;ATmRJ;;ASjRE;EACE,iBAAA;AToRJ;;ASlRE;EACE,iBAAA;EACA,kBAAA;ATqRJ;;ASnRE;EACE,gBAAA;EACA,mBAAA;ATsRJ;;ASnRE;EACE,WAAA;ATsRJ;;ASpRE;EACE,eAAA;ATuRJ;;ASrRE;EACE,iBAAA;ATwRJ;;AStRE;EACE,kBAAA;ATyRJ;;ASvRE;EACE,gBAAA;AT0RJ;;ASxRE;EACE,gBAAA;EACA,iBAAA;AT2RJ;;ASzRE;EACE,eAAA;EACA,kBAAA;AT4RJ;;ASzUE;EACE,YAAA;AT4UJ;;AS1UE;EACE,gBAAA;AT6UJ;;AS3UE;EACE,kBAAA;AT8UJ;;AS5UE;EACE,mBAAA;AT+UJ;;AS7UE;EACE,iBAAA;ATgVJ;;AS9UE;EACE,iBAAA;EACA,kBAAA;ATiVJ;;AS/UE;EACE,gBAAA;EACA,mBAAA;ATkVJ;;AS/UE;EACE,WAAA;ATkVJ;;AShVE;EACE,eAAA;ATmVJ;;ASjVE;EACE,iBAAA;AToVJ;;ASlVE;EACE,kBAAA;ATqVJ;;ASnVE;EACE,gBAAA;ATsVJ;;ASpVE;EACE,gBAAA;EACA,iBAAA;ATuVJ;;ASrVE;EACE,eAAA;EACA,kBAAA;ATwVJ;;ASrYE;EACE,aAAA;ATwYJ;;AStYE;EACE,iBAAA;ATyYJ;;ASvYE;EACE,mBAAA;AT0YJ;;ASxYE;EACE,oBAAA;AT2YJ;;ASzYE;EACE,kBAAA;AT4YJ;;AS1YE;EACE,kBAAA;EACA,mBAAA;AT6YJ;;AS3YE;EACE,iBAAA;EACA,oBAAA;AT8YJ;;AS3YE;EACE,YAAA;AT8YJ;;AS5YE;EACE,gBAAA;AT+YJ;;AS7YE;EACE,kBAAA;ATgZJ;;AS9YE;EACE,mBAAA;ATiZJ;;AS/YE;EACE,iBAAA;ATkZJ;;AShZE;EACE,iBAAA;EACA,kBAAA;ATmZJ;;ASjZE;EACE,gBAAA;EACA,mBAAA;AToZJ;;ASjcE;EACE,aAAA;ATocJ;;ASlcE;EACE,iBAAA;ATqcJ;;ASncE;EACE,mBAAA;ATscJ;;ASpcE;EACE,oBAAA;ATucJ;;ASrcE;EACE,kBAAA;ATwcJ;;AStcE;EACE,kBAAA;EACA,mBAAA;ATycJ;;ASvcE;EACE,iBAAA;EACA,oBAAA;AT0cJ;;ASvcE;EACE,YAAA;AT0cJ;;ASxcE;EACE,gBAAA;AT2cJ;;ASzcE;EACE,kBAAA;AT4cJ;;AS1cE;EACE,mBAAA;AT6cJ;;AS3cE;EACE,iBAAA;AT8cJ;;AS5cE;EACE,iBAAA;EACA,kBAAA;AT+cJ;;AS7cE;EACE,gBAAA;EACA,mBAAA;ATgdJ;;AS7fE;EACE,aAAA;ATggBJ;;AS9fE;EACE,iBAAA;ATigBJ;;AS/fE;EACE,mBAAA;ATkgBJ;;AShgBE;EACE,oBAAA;ATmgBJ;;ASjgBE;EACE,kBAAA;ATogBJ;;ASlgBE;EACE,kBAAA;EACA,mBAAA;ATqgBJ;;ASngBE;EACE,iBAAA;EACA,oBAAA;ATsgBJ;;ASngBE;EACE,YAAA;ATsgBJ;;ASpgBE;EACE,gBAAA;ATugBJ;;ASrgBE;EACE,kBAAA;ATwgBJ;;AStgBE;EACE,mBAAA;ATygBJ;;ASvgBE;EACE,iBAAA;AT0gBJ;;ASxgBE;EACE,iBAAA;EACA,kBAAA;AT2gBJ;;ASzgBE;EACE,gBAAA;EACA,mBAAA;AT4gBJ;;ASzjBE;EACE,aAAA;AT4jBJ;;AS1jBE;EACE,iBAAA;AT6jBJ;;AS3jBE;EACE,mBAAA;AT8jBJ;;AS5jBE;EACE,oBAAA;AT+jBJ;;AS7jBE;EACE,kBAAA;ATgkBJ;;AS9jBE;EACE,kBAAA;EACA,mBAAA;ATikBJ;;AS/jBE;EACE,iBAAA;EACA,oBAAA;ATkkBJ;;AS/jBE;EACE,YAAA;ATkkBJ;;AShkBE;EACE,gBAAA;ATmkBJ;;ASjkBE;EACE,kBAAA;ATokBJ;;ASlkBE;EACE,mBAAA;ATqkBJ;;ASnkBE;EACE,iBAAA;ATskBJ;;ASpkBE;EACE,iBAAA;EACA,kBAAA;ATukBJ;;ASrkBE;EACE,gBAAA;EACA,mBAAA;ATwkBJ;;ASrnBE;EACE,aAAA;ATwnBJ;;AStnBE;EACE,iBAAA;ATynBJ;;ASvnBE;EACE,mBAAA;AT0nBJ;;ASxnBE;EACE,oBAAA;AT2nBJ;;ASznBE;EACE,kBAAA;AT4nBJ;;AS1nBE;EACE,kBAAA;EACA,mBAAA;AT6nBJ;;AS3nBE;EACE,iBAAA;EACA,oBAAA;AT8nBJ;;AS3nBE;EACE,YAAA;AT8nBJ;;AS5nBE;EACE,gBAAA;AT+nBJ;;AS7nBE;EACE,kBAAA;ATgoBJ;;AS9nBE;EACE,mBAAA;ATioBJ;;AS/nBE;EACE,iBAAA;ATkoBJ;;AShoBE;EACE,iBAAA;EACA,kBAAA;ATmoBJ;;ASjoBE;EACE,gBAAA;EACA,mBAAA;ATooBJ;;ASjrBE;EACE,aAAA;ATorBJ;;ASlrBE;EACE,iBAAA;ATqrBJ;;ASnrBE;EACE,mBAAA;ATsrBJ;;ASprBE;EACE,oBAAA;ATurBJ;;ASrrBE;EACE,kBAAA;ATwrBJ;;AStrBE;EACE,kBAAA;EACA,mBAAA;ATyrBJ;;ASvrBE;EACE,iBAAA;EACA,oBAAA;AT0rBJ;;ASvrBE;EACE,YAAA;AT0rBJ;;ASxrBE;EACE,gBAAA;AT2rBJ;;ASzrBE;EACE,kBAAA;AT4rBJ;;AS1rBE;EACE,mBAAA;AT6rBJ;;AS3rBE;EACE,iBAAA;AT8rBJ;;AS5rBE;EACE,iBAAA;EACA,kBAAA;AT+rBJ;;AS7rBE;EACE,gBAAA;EACA,mBAAA;ATgsBJ;;AS7uBE;EACE,aAAA;ATgvBJ;;AS9uBE;EACE,iBAAA;ATivBJ;;AS/uBE;EACE,mBAAA;ATkvBJ;;AShvBE;EACE,oBAAA;ATmvBJ;;ASjvBE;EACE,kBAAA;ATovBJ;;ASlvBE;EACE,kBAAA;EACA,mBAAA;ATqvBJ;;ASnvBE;EACE,iBAAA;EACA,oBAAA;ATsvBJ;;ASnvBE;EACE,YAAA;ATsvBJ;;ASpvBE;EACE,gBAAA;ATuvBJ;;ASrvBE;EACE,kBAAA;ATwvBJ;;AStvBE;EACE,mBAAA;ATyvBJ;;ASvvBE;EACE,iBAAA;AT0vBJ;;ASxvBE;EACE,iBAAA;EACA,kBAAA;AT2vBJ;;ASzvBE;EACE,gBAAA;EACA,mBAAA;AT4vBJ;;ASzyBE;EACE,aAAA;AT4yBJ;;AS1yBE;EACE,iBAAA;AT6yBJ;;AS3yBE;EACE,mBAAA;AT8yBJ;;AS5yBE;EACE,oBAAA;AT+yBJ;;AS7yBE;EACE,kBAAA;ATgzBJ;;AS9yBE;EACE,kBAAA;EACA,mBAAA;ATizBJ;;AS/yBE;EACE,iBAAA;EACA,oBAAA;ATkzBJ;;AS/yBE;EACE,YAAA;ATkzBJ;;AShzBE;EACE,gBAAA;ATmzBJ;;ASjzBE;EACE,kBAAA;ATozBJ;;ASlzBE;EACE,mBAAA;ATqzBJ;;ASnzBE;EACE,iBAAA;ATszBJ;;ASpzBE;EACE,iBAAA;EACA,kBAAA;ATuzBJ;;ASrzBE;EACE,gBAAA;EACA,mBAAA;ATwzBJ;;ASr2BE;EACE,aAAA;ATw2BJ;;ASt2BE;EACE,iBAAA;ATy2BJ;;ASv2BE;EACE,mBAAA;AT02BJ;;ASx2BE;EACE,oBAAA;AT22BJ;;ASz2BE;EACE,kBAAA;AT42BJ;;AS12BE;EACE,kBAAA;EACA,mBAAA;AT62BJ;;AS32BE;EACE,iBAAA;EACA,oBAAA;AT82BJ;;AS32BE;EACE,YAAA;AT82BJ;;AS52BE;EACE,gBAAA;AT+2BJ;;AS72BE;EACE,kBAAA;ATg3BJ;;AS92BE;EACE,mBAAA;ATi3BJ;;AS/2BE;EACE,iBAAA;ATk3BJ;;ASh3BE;EACE,iBAAA;EACA,kBAAA;ATm3BJ;;ASj3BE;EACE,gBAAA;EACA,mBAAA;ATo3BJ;;AUx6BA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AVu6BF;;AUp6BA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AVu6BF;;AUp6BA,iDAAA;AACA;EACE,wCAAA;AVu6BF;;AUp6BA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AVu6BF;AUr6BE;EACE,aAAA;AVu6BJ;;AUn6BA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVs6BF;;AUn6BA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVs6BF;;AUl6BA;EACE,oCAAA;EACA,yBAAA;AVq6BF;;AUl6BA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AVq6BF;;AUj6BA;EACE,kCAAA;AVo6BF;;AUj6BA;EACE,6BAAA;AVo6BF;;AUj6BA;EACE,kCAAA;AVo6BF;;AUj6BA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVo6BF;;AUh6BA,2BAAA;AAEA;EACE,SAAA;AVk6BF;;AU/5BA;EACE,WAAA;EACA,2BAAA;AVk6BF;AUh6BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AVk6BJ;AU/5BE;EACE,uBAAA;AVi6BJ;AU95BE;EACE,kBAAA;AVg6BJ;;AU55BA;EACE,WAAA;EACA,2BAAA;AV+5BF;;AU55BA;EACE,WAAA;EACA,gBAAA;AV+5BF;AU75BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AV+5BJ;AU55BE;EACE,uBAAA;AV85BJ;AU35BE;EACE,kBAAA;AV65BJ;;AUz5BA;EACE,WAAA;EACA,gBAAA;AV45BF;AU15BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AV45BJ;AUz5BE;EACE,uBAAA;AV25BJ;AUx5BE;EACE,kBAAA;AV05BJ;;AUt5BA;EACE,WAAA;EACA,gBAAA;AVy5BF;AUv5BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AVy5BJ;AUt5BE;EACE,uBAAA;AVw5BJ;AUr5BE;EACE,kBAAA;AVu5BJ;;AUn5BA;EACE,aAAA;AVs5BF;;AUn5BA;EACE,2BAAA;AVs5BF;AUn5BI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AVq5BN;AUl5BI;EACE,iBAAA;EACA,eAAA;AVo5BN;AUj5BI;EACE,mBAAA;AVm5BN;AUh5BI;EACE,2CAAA;AVk5BN;;AU74BA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AVg5BF;;AU74BA;EACE,oBAAA;EACA,mBAAA;AVg5BF;AU94BE;EACE,YAAA;EACA,WAAA;AVg5BJ;;AU34BI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EV+4BJ;AACF;;AU54BA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EVg5BF;AACF;AU94BE;EACE,8BAAA;AVg5BJ;;AU54BA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVg5BF;AACF;AU94BE;EACE,8BAAA;AVg5BJ;;AU54BA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVg5BF;AACF;;AU74BA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AVg5BF;;AU74BA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AVg5BF;;AU94BA;EACE,mDAAA;EACA,4CAAA;AVi5BF;;AU94BA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AVi5BF;;AU/4BA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AVk5BF;;AUh5BA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVm5BF;;AUj5BA;EACE,2BAAA;AVo5BF;;AUj5BE;EACE,YAAA;AVo5BJ;AUl5BE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVo5BJ;AUj5BI;EACE,yBAAA;EACA,oCAAA;AVm5BN;AU/4BE;EACE,uBAAA;AVi5BJ;AU/4BE;EACE,uBAAA;AVi5BJ;AU/4BE;EACE,uBAAA;AVi5BJ;;AU74BA;EACE;IACE,4BAAA;IACA,eAAA;EVg5BF;EU74BA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EV+4BF;EU54BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV84BF;EU54BA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EV84BF;EU54BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV84BF;AACF;AU34BA;EACE;IACE,kBAAA;EV64BF;EU34BA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EV64BF;EU14BA;IACE,kBAAA;IACA,0BAAA;EV44BF;EU14BA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EV44BF;EU14BE;IACF,kBAAA;IACE,0BAAA;EV44BF;AACF;AUz4BA;EACE;IACE,UAAA;EV24BF;AACF;AUx4BA;EACE,wCAAA;AV04BF;;AUv4BA;EACE;IACE,iBAAA;IACA,8CAAA;EV04BF;AACF;AUv4BA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AVy4BF;AUv4BE;EACE,sBAAA;AVy4BJ;;AUr4BA;EACE,wBAAA;AVw4BF;;AUt4BA;EACE,qBAAA,EAAA,wCAAA;AVy4BF;;AUv4BA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AV04BF;AUx4BE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AVy4BJ;AUv4BI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AVy4BN;AUt4BI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AVw4BN;AUt4BI;EApBF;IAqBI,WAAA;IACA,cAAA;EVy4BJ;AACF;AUt4BE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AVw4BJ;AUt4BI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AVw4BN;AUp4BE;EACE,iBAAA;EACA,uBAAA;AVs4BJ;AUn4BI;EADF;IAEI,eAAA;EVs4BJ;AACF;AUn4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AVq4BJ;AUl4BE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AVo4BJ;AUl4BI;EACE,iBAAA;AVo4BN;;AU/3BA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AVk4BF;;AU/3BA;EACE,qBAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,YAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,YAAA;AVk4BF;;AUh4BA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AVk4BF;;AU93BA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AVi4BF;;AU/3BA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AVk4BF;AUh4BE;EACE,WAAA;AVk4BJ;AU/3BE;EACE;IACE,aAAA;EVi4BJ;AACF;;AU73BA;EACE,aAAA;EACA,mBAAA;AVg4BF;AU93BE;EACE,WAAA;AVg4BJ;AU73BE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AV+3BJ;AU53BE;EACE,uBAAA;AV83BJ;AU33BE;EACE,uBAAA;AV63BJ;;AUz3BA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AV43BF;;AUz3BA;EACE,uBAAA;AV43BF;;AUz3BA;EACE,aAAA;EACA,eAAA;AV43BF;AU13BE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AV43BJ;;AUx3BA;EACE,gBAAA;EACA,kBAAA;AV23BF;;AUv3BA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AV03BF;;AUt3BE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AVy3BJ;;AUp3BE;EACE,mCAAA;AVu3BJ;AUp3BE;EACE,wBAAA;EACA,kBAAA;AVs3BJ;;AUj3BE;EACE,kCAAA;AVo3BJ;AUj3BE;EACE,uBAAA;EACA,kBAAA;AVm3BJ;;AU/2BA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AVk3BF;AUh3BE;EACE,sCAAA;EACA,+CAAA;AVk3BJ;;AU92BA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVi3BF;;AU92BA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVi3BF;;AU92BA;EAEE,qBAAA;AVg3BF;;AUz2BA;EAEE,cAAA;AV22BF;;AUx2BA;EACM,2BAAA;AV22BN;;AUz2BA;EACE,2BAAA;AV42BF;;AU12BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AV62BF;;AU12BA;EACE,aAAA;EACA,iBAAA;AV62BF;;AU12BA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AV62BF;AU32BE;EACE,kBAAA;AV62BJ;;AUz2BA;EACE,kBAAA;EACA,kBAAA;AV42BF;;AU12BA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AV42BF;AU12BE;EACE,gBAAA;AV42BJ;AU12BE;EACE,WAAA;AV42BJ;;AUx2BA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AV22BF;;AUx2BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AV22BF;;AUx2BA;EACE,sBAAA;EACA,YAAA;AV22BF;;AUx2BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AV22BF;;AUz2BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AV42BF;;AU12BA;EACE,iCAAA;AV62BF;;AU32BA;EACE,sBAAA;AV82BF;;AU52BA;EACE,iDAAA;EACA,mDAAA;AV+2BF;;AU52BE;EACE,8BAAA;AV+2BJ;;AU32BE;EACE,8BAAA;AV82BJ;;AU32BA;EACE,uBAAA;AV82BF;;AU52BA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AV82BF;;AU52BA;EACE,6BAAA;EACA,kBAAA;AV+2BF;;AU72BA;EACE,oCAAA;AVg3BF;;AU92BA;EACE,kCAAA;AVi3BF;;AU92BE;EADF;IAEI,WAAA;EVk3BF;AACF;;AU/2BA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AVk3BF;;AU92BE;EACE,qBAAA;AVi3BJ;AUt2BA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AVw2BJ;;AUt2BA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AVy2BJ;;AUt2BA;EACE,2BAAA;AVy2BF;;AUr2BE;EADF;IAEI,wBAAA;EVy2BF;AACF;;AUv2BA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AV02BF;;AUv2BA;EAAO,iBAAA;AV22BP;;AU12BA;EAAO,uBAAA;AV82BP;;AU72BA;EAAO,sBAAA;AVi3BP;;AUh3BA;EAAO,oBAAA;AVo3BP;;AUn3BA;EAAO,sBAAA;AVu3BP;;AUt3BA;EAAO,oBAAA;AV03BP;;AUv3BA;EAAQ,wBAAA;AV23BR;;AU13BA;EAAQ,8BAAA;AV83BR;;AU73BA;EAAQ,6BAAA;AVi4BR;;AUh4BA;EAAQ,2BAAA;AVo4BR;;AUn4BA;EAAQ,6BAAA;AVu4BR;;AUt4BA;EAAQ,2BAAA;AV04BR;;AUv4BA;EAAQ,qBAAA;AV24BR;;AU14BA;EAAQ,2BAAA;AV84BR;;AU74BA;EAAQ,0BAAA;AVi5BR;;AUh5BA;EAAQ,wBAAA;AVo5BR;;AUn5BA;EAAQ,0BAAA;AVu5BR;;AUt5BA;EAAQ,wBAAA;AV05BR;;AUz5BA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AV45BF;;AUz5BA;EAAS,mBAAA;EAAqB,oBAAA;AV85B9B;;AU75BA;EAAS,oBAAA;EAAsB,qBAAA;AVk6B/B;;AUj6BA;EAAS,aAAA;EAAe,cAAA;AVs6BxB;;AUr6BA;EAAS,oBAAA;EAAsB,qBAAA;AV06B/B;;AUz6BA;EAAS,oBAAA;EAAsB,qBAAA;AV86B/B;;AU76BA;EAAS,aAAA;EAAe,cAAA;AVk7BxB;;AUj7BA;EAAS,oBAAA;EAAsB,qBAAA;AVs7B/B;;AUr7BA;EAAS,oBAAA;EAAsB,qBAAA;AV07B/B;;AUz7BA;EAAS,aAAA;EAAe,cAAA;AV87BxB;;AU77BA;EAAU,oBAAA;EAAsB,qBAAA;AVk8BhC;;AUj8BA;EAAU,oBAAA;EAAsB,qBAAA;AVs8BhC;;AUr8BA;EAAU,aAAA;EAAe,cAAA;AV08BzB;;AUx8BA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV68BjC;EU58BA;IAAY,oBAAA;IAAsB,qBAAA;EVg9BlC;EU/8BA;IAAY,aAAA;IAAe,cAAA;EVm9B3B;EUl9BA;IAAY,oBAAA;IAAsB,qBAAA;EVs9BlC;EUr9BA;IAAY,oBAAA;IAAsB,qBAAA;EVy9BlC;EUx9BA;IAAY,aAAA;IAAe,cAAA;EV49B3B;EU39BA;IAAY,oBAAA;IAAsB,qBAAA;EV+9BlC;EU99BA;IAAY,oBAAA;IAAsB,qBAAA;EVk+BlC;EUj+BA;IAAY,aAAA;IAAe,cAAA;EVq+B3B;EUp+BA;IAAa,oBAAA;IAAsB,qBAAA;EVw+BnC;EUv+BA;IAAa,oBAAA;IAAsB,qBAAA;EV2+BnC;EU1+BA;IAAa,aAAA;IAAe,cAAA;EV8+B5B;AACF;AU5+BA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVg/BjC;EU/+BA;IAAY,oBAAA;IAAsB,qBAAA;EVm/BlC;EUl/BA;IAAY,aAAA;IAAe,cAAA;EVs/B3B;EUr/BA;IAAY,oBAAA;IAAsB,qBAAA;EVy/BlC;EUx/BA;IAAY,oBAAA;IAAsB,qBAAA;EV4/BlC;EU3/BA;IAAY,aAAA;IAAe,cAAA;EV+/B3B;EU9/BA;IAAY,oBAAA;IAAsB,qBAAA;EVkgClC;EUjgCA;IAAY,oBAAA;IAAsB,qBAAA;EVqgClC;EUpgCA;IAAY,aAAA;IAAe,cAAA;EVwgC3B;EUvgCA;IAAa,oBAAA;IAAsB,qBAAA;EV2gCnC;EU1gCA;IAAa,oBAAA;IAAsB,qBAAA;EV8gCnC;EU7gCA;IAAa,cAAA;IAAgB,eAAA;EVihC7B;AACF;AU/gCA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVmhCjC;EUlhCA;IAAY,oBAAA;IAAsB,qBAAA;EVshClC;EUrhCA;IAAY,aAAA;IAAe,cAAA;EVyhC3B;EUxhCA;IAAY,oBAAA;IAAsB,qBAAA;EV4hClC;EU3hCA;IAAY,oBAAA;IAAsB,qBAAA;EV+hClC;EU9hCA;IAAY,aAAA;IAAe,cAAA;EVkiC3B;EUjiCA;IAAY,oBAAA;IAAsB,qBAAA;EVqiClC;EUpiCA;IAAY,oBAAA;IAAsB,qBAAA;EVwiClC;EUviCA;IAAY,aAAA;IAAe,cAAA;EV2iC3B;EU1iCA;IAAa,oBAAA;IAAsB,qBAAA;EV8iCnC;EU7iCA;IAAa,oBAAA;IAAsB,qBAAA;EVijCnC;EUhjCA;IAAa,aAAA;IAAe,cAAA;EVojC5B;AACF;AUljCA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVsjCjC;EUrjCA;IAAY,oBAAA;IAAsB,qBAAA;EVyjClC;EUxjCA;IAAY,aAAA;IAAe,cAAA;EV4jC3B;EU3jCA;IAAY,oBAAA;IAAsB,qBAAA;EV+jClC;EU9jCA;IAAY,oBAAA;IAAsB,qBAAA;EVkkClC;EUjkCA;IAAY,aAAA;IAAe,cAAA;EVqkC3B;EUpkCA;IAAY,oBAAA;IAAsB,qBAAA;EVwkClC;EUvkCA;IAAY,oBAAA;IAAsB,qBAAA;EV2kClC;EU1kCA;IAAY,aAAA;IAAe,cAAA;EV8kC3B;EU7kCA;IAAa,oBAAA;IAAsB,qBAAA;EVilCnC;EUhlCA;IAAa,oBAAA;IAAsB,qBAAA;EVolCnC;EUnlCA;IAAa,aAAA;IAAe,cAAA;EVulC5B;AACF;AUrlCA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EVylClC;EUxlCA;IAAa,oBAAA;IAAsB,qBAAA;EV4lCnC;EU3lCA;IAAa,aAAA;IAAe,cAAA;EV+lC5B;EU9lCA;IAAa,oBAAA;IAAsB,qBAAA;EVkmCnC;EUjmCA;IAAa,oBAAA;IAAsB,qBAAA;EVqmCnC;EUpmCA;IAAa,aAAA;IAAe,cAAA;EVwmC5B;EUvmCA;IAAa,oBAAA;IAAsB,qBAAA;EV2mCnC;EU1mCA;IAAa,oBAAA;IAAsB,qBAAA;EV8mCnC;EU7mCA;IAAa,aAAA;IAAe,cAAA;EVinC5B;EUhnCA;IAAc,oBAAA;IAAsB,qBAAA;EVonCpC;EUnnCA;IAAc,oBAAA;IAAsB,qBAAA;EVunCpC;EUtnCA;IAAc,aAAA;IAAe,cAAA;EV0nC7B;AACF;AUznCA;EACE,0BAAA;AV2nCF;;AUznCA;EACE,iBAAA;AV4nCF;;AU1nCA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AV6nCJ;;AU1nCA;EACI,uBAAA;AV6nCJ;;AU1nCA;EACI,aAAA;AV6nCJ;;AU1nCA;EAEI,gCAAA;EACA,oCAAA;AV4nCJ;;AAtsEA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AAysEF;AAtsEI;EACE,iBAAA;AAwsEN;AArsEI;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AAusEN;AArsEM;EACE,UAAA;AAusER;AApsEM;EACE,oBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAssER;AAjsEE;EACE,WAAA;AAmsEJ;AAjsEI;EACE,WAAA;AAmsEN;AA/rEE;EACE,gBAAA;AAisEJ;AA/rEE;EACE,gBAAA;EACA,oBAAA;EACA,aAAA;EAEA,uBAAA;AAgsEJ;AA9rEI;EAPF;IAQI,sBAAA;EAisEJ;AACF;AA/rEI;EACE,kBAAA;AAisEN;;ACnvEE;EACE,gBAAA;EAIA,kBAAA;ADmvEJ;AC5uEI;EACE,wBAAA;AD8uEN;;AC1uEE;EACE,iBAAA;AD6uEJ;;AC1uEE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADyuEJ;AE1tEI;EDXE,aAAA;ADwuEN;;AE5wEE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AFmwEJ;AEjwEI;EACE,UAAA;EACA,QAAA;AFmwEN;;AGnxEE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AHmxEJ;;AG/wEE;EACE,eAAA;EACA,aA3BwB;AH6yE5B;AGhxEI;EAGE,aAAA;AHgxEN;;AGxwEE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AHqzElB;;AGvwEE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AHqwEJ;;AGlwEE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AHmwEJ;AGjwEI;EACE,UAAA;AHmwEN;AG9vEM;EAGE,YAAA;AH8vER;;AGzvEE;EACE,+BAtFqB;AHk1EzB;;AGzvEE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AH2vEJ;AGrvEI;EACE,UAAA;EACA,mBAAA;AHuvEN;;AGnvEE;EACE,gBAAA;AHsvEJ;;AGjvEE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AH2uEJ;;AGvuEE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AHkuEJ;;AIn3EE;EACE,YAAA;AJs3EJ;;AIh3EE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJo3EJ;;AI32EE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJ+2EJ;;AIr2EE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJs2EJ;;AIn2EE;EAEE,6CAAA;AJq2EJ;;AKp4EE;EACE,kBAAA;ALu4EJ;AKr4EI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;ALg4EN;AKx3EI;EACE,WAAA;AL03EN;;AE/0EM;EG7BA,oCAAA;ALg3EN;;AK35EE;EACE,kBAAA;AL85EJ;AK55EI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALu5EN;AK/4EI;EACE,WAAA;ALi5EN;;AEt2EM;EG7BA,wCAAA;ALu4EN;;AOh8EA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARu8EF;;AQp8EA;;;;;;EAME,qCAAA;EACA,gBAAA;ARu8EF;;AQp8EA;EACE,eAAA;EACA,iBAAA;ARu8EF;;AQp8EA;EACE,eAAA;EACA,iBAAA;ARu8EF;;AQp8EA;EACE,eAAA;EACA,iBAAA;ARu8EF;;AQp8EA;EACE,eAAA;EACA,iBAAA;ARu8EF;;AQp8EA;EACE,eAAA;EACA,iBAAA;ARu8EF;;AQp8EA;EACE,eAAA;EACA,iBAAA;ARu8EF;;AQp8EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARu8EF;;AQp8EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARu8EF;;AQp8EA;EACE,gBAAA;EACA,eAAA;ARu8EF;;AOzgFA;;;;;CAAA;AEeE;EACE,YAAA;ATmgFJ;;ASjgFE;EACE,gBAAA;ATogFJ;;ASlgFE;EACE,kBAAA;ATqgFJ;;ASngFE;EACE,mBAAA;ATsgFJ;;ASpgFE;EACE,iBAAA;ATugFJ;;ASrgFE;EACE,iBAAA;EACA,kBAAA;ATwgFJ;;AStgFE;EACE,gBAAA;EACA,mBAAA;ATygFJ;;AStgFE;EACE,WAAA;ATygFJ;;ASvgFE;EACE,eAAA;AT0gFJ;;ASxgFE;EACE,iBAAA;AT2gFJ;;ASzgFE;EACE,kBAAA;AT4gFJ;;AS1gFE;EACE,gBAAA;AT6gFJ;;AS3gFE;EACE,gBAAA;EACA,iBAAA;AT8gFJ;;AS5gFE;EACE,eAAA;EACA,kBAAA;AT+gFJ;;AS5jFE;EACE,YAAA;AT+jFJ;;AS7jFE;EACE,gBAAA;ATgkFJ;;AS9jFE;EACE,kBAAA;ATikFJ;;AS/jFE;EACE,mBAAA;ATkkFJ;;AShkFE;EACE,iBAAA;ATmkFJ;;ASjkFE;EACE,iBAAA;EACA,kBAAA;ATokFJ;;ASlkFE;EACE,gBAAA;EACA,mBAAA;ATqkFJ;;ASlkFE;EACE,WAAA;ATqkFJ;;ASnkFE;EACE,eAAA;ATskFJ;;ASpkFE;EACE,iBAAA;ATukFJ;;ASrkFE;EACE,kBAAA;ATwkFJ;;AStkFE;EACE,gBAAA;ATykFJ;;ASvkFE;EACE,gBAAA;EACA,iBAAA;AT0kFJ;;ASxkFE;EACE,eAAA;EACA,kBAAA;AT2kFJ;;ASxnFE;EACE,aAAA;AT2nFJ;;ASznFE;EACE,iBAAA;AT4nFJ;;AS1nFE;EACE,mBAAA;AT6nFJ;;AS3nFE;EACE,oBAAA;AT8nFJ;;AS5nFE;EACE,kBAAA;AT+nFJ;;AS7nFE;EACE,kBAAA;EACA,mBAAA;ATgoFJ;;AS9nFE;EACE,iBAAA;EACA,oBAAA;ATioFJ;;AS9nFE;EACE,YAAA;ATioFJ;;AS/nFE;EACE,gBAAA;ATkoFJ;;AShoFE;EACE,kBAAA;ATmoFJ;;ASjoFE;EACE,mBAAA;ATooFJ;;ASloFE;EACE,iBAAA;ATqoFJ;;ASnoFE;EACE,iBAAA;EACA,kBAAA;ATsoFJ;;ASpoFE;EACE,gBAAA;EACA,mBAAA;ATuoFJ;;ASprFE;EACE,aAAA;ATurFJ;;ASrrFE;EACE,iBAAA;ATwrFJ;;AStrFE;EACE,mBAAA;ATyrFJ;;ASvrFE;EACE,oBAAA;AT0rFJ;;ASxrFE;EACE,kBAAA;AT2rFJ;;ASzrFE;EACE,kBAAA;EACA,mBAAA;AT4rFJ;;AS1rFE;EACE,iBAAA;EACA,oBAAA;AT6rFJ;;AS1rFE;EACE,YAAA;AT6rFJ;;AS3rFE;EACE,gBAAA;AT8rFJ;;AS5rFE;EACE,kBAAA;AT+rFJ;;AS7rFE;EACE,mBAAA;ATgsFJ;;AS9rFE;EACE,iBAAA;ATisFJ;;AS/rFE;EACE,iBAAA;EACA,kBAAA;ATksFJ;;AShsFE;EACE,gBAAA;EACA,mBAAA;ATmsFJ;;AShvFE;EACE,aAAA;ATmvFJ;;ASjvFE;EACE,iBAAA;ATovFJ;;ASlvFE;EACE,mBAAA;ATqvFJ;;ASnvFE;EACE,oBAAA;ATsvFJ;;ASpvFE;EACE,kBAAA;ATuvFJ;;ASrvFE;EACE,kBAAA;EACA,mBAAA;ATwvFJ;;AStvFE;EACE,iBAAA;EACA,oBAAA;ATyvFJ;;AStvFE;EACE,YAAA;ATyvFJ;;ASvvFE;EACE,gBAAA;AT0vFJ;;ASxvFE;EACE,kBAAA;AT2vFJ;;ASzvFE;EACE,mBAAA;AT4vFJ;;AS1vFE;EACE,iBAAA;AT6vFJ;;AS3vFE;EACE,iBAAA;EACA,kBAAA;AT8vFJ;;AS5vFE;EACE,gBAAA;EACA,mBAAA;AT+vFJ;;AS5yFE;EACE,aAAA;AT+yFJ;;AS7yFE;EACE,iBAAA;ATgzFJ;;AS9yFE;EACE,mBAAA;ATizFJ;;AS/yFE;EACE,oBAAA;ATkzFJ;;AShzFE;EACE,kBAAA;ATmzFJ;;ASjzFE;EACE,kBAAA;EACA,mBAAA;ATozFJ;;ASlzFE;EACE,iBAAA;EACA,oBAAA;ATqzFJ;;ASlzFE;EACE,YAAA;ATqzFJ;;ASnzFE;EACE,gBAAA;ATszFJ;;ASpzFE;EACE,kBAAA;ATuzFJ;;ASrzFE;EACE,mBAAA;ATwzFJ;;AStzFE;EACE,iBAAA;ATyzFJ;;ASvzFE;EACE,iBAAA;EACA,kBAAA;AT0zFJ;;ASxzFE;EACE,gBAAA;EACA,mBAAA;AT2zFJ;;ASx2FE;EACE,aAAA;AT22FJ;;ASz2FE;EACE,iBAAA;AT42FJ;;AS12FE;EACE,mBAAA;AT62FJ;;AS32FE;EACE,oBAAA;AT82FJ;;AS52FE;EACE,kBAAA;AT+2FJ;;AS72FE;EACE,kBAAA;EACA,mBAAA;ATg3FJ;;AS92FE;EACE,iBAAA;EACA,oBAAA;ATi3FJ;;AS92FE;EACE,YAAA;ATi3FJ;;AS/2FE;EACE,gBAAA;ATk3FJ;;ASh3FE;EACE,kBAAA;ATm3FJ;;ASj3FE;EACE,mBAAA;ATo3FJ;;ASl3FE;EACE,iBAAA;ATq3FJ;;ASn3FE;EACE,iBAAA;EACA,kBAAA;ATs3FJ;;ASp3FE;EACE,gBAAA;EACA,mBAAA;ATu3FJ;;ASp6FE;EACE,aAAA;ATu6FJ;;ASr6FE;EACE,iBAAA;ATw6FJ;;ASt6FE;EACE,mBAAA;ATy6FJ;;ASv6FE;EACE,oBAAA;AT06FJ;;ASx6FE;EACE,kBAAA;AT26FJ;;ASz6FE;EACE,kBAAA;EACA,mBAAA;AT46FJ;;AS16FE;EACE,iBAAA;EACA,oBAAA;AT66FJ;;AS16FE;EACE,YAAA;AT66FJ;;AS36FE;EACE,gBAAA;AT86FJ;;AS56FE;EACE,kBAAA;AT+6FJ;;AS76FE;EACE,mBAAA;ATg7FJ;;AS96FE;EACE,iBAAA;ATi7FJ;;AS/6FE;EACE,iBAAA;EACA,kBAAA;ATk7FJ;;ASh7FE;EACE,gBAAA;EACA,mBAAA;ATm7FJ;;ASh+FE;EACE,aAAA;ATm+FJ;;ASj+FE;EACE,iBAAA;ATo+FJ;;ASl+FE;EACE,mBAAA;ATq+FJ;;ASn+FE;EACE,oBAAA;ATs+FJ;;ASp+FE;EACE,kBAAA;ATu+FJ;;ASr+FE;EACE,kBAAA;EACA,mBAAA;ATw+FJ;;ASt+FE;EACE,iBAAA;EACA,oBAAA;ATy+FJ;;ASt+FE;EACE,YAAA;ATy+FJ;;ASv+FE;EACE,gBAAA;AT0+FJ;;ASx+FE;EACE,kBAAA;AT2+FJ;;ASz+FE;EACE,mBAAA;AT4+FJ;;AS1+FE;EACE,iBAAA;AT6+FJ;;AS3+FE;EACE,iBAAA;EACA,kBAAA;AT8+FJ;;AS5+FE;EACE,gBAAA;EACA,mBAAA;AT++FJ;;AS5hGE;EACE,aAAA;AT+hGJ;;AS7hGE;EACE,iBAAA;ATgiGJ;;AS9hGE;EACE,mBAAA;ATiiGJ;;AS/hGE;EACE,oBAAA;ATkiGJ;;AShiGE;EACE,kBAAA;ATmiGJ;;ASjiGE;EACE,kBAAA;EACA,mBAAA;AToiGJ;;ASliGE;EACE,iBAAA;EACA,oBAAA;ATqiGJ;;ASliGE;EACE,YAAA;ATqiGJ;;ASniGE;EACE,gBAAA;ATsiGJ;;ASpiGE;EACE,kBAAA;ATuiGJ;;ASriGE;EACE,mBAAA;ATwiGJ;;AStiGE;EACE,iBAAA;ATyiGJ;;ASviGE;EACE,iBAAA;EACA,kBAAA;AT0iGJ;;ASxiGE;EACE,gBAAA;EACA,mBAAA;AT2iGJ;;ASxlGE;EACE,aAAA;AT2lGJ;;ASzlGE;EACE,iBAAA;AT4lGJ;;AS1lGE;EACE,mBAAA;AT6lGJ;;AS3lGE;EACE,oBAAA;AT8lGJ;;AS5lGE;EACE,kBAAA;AT+lGJ;;AS7lGE;EACE,kBAAA;EACA,mBAAA;ATgmGJ;;AS9lGE;EACE,iBAAA;EACA,oBAAA;ATimGJ;;AS9lGE;EACE,YAAA;ATimGJ;;AS/lGE;EACE,gBAAA;ATkmGJ;;AShmGE;EACE,kBAAA;ATmmGJ;;ASjmGE;EACE,mBAAA;ATomGJ;;ASlmGE;EACE,iBAAA;ATqmGJ;;ASnmGE;EACE,iBAAA;EACA,kBAAA;ATsmGJ;;ASpmGE;EACE,gBAAA;EACA,mBAAA;ATumGJ;;AU3pGA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AV0pGF;;AUvpGA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AV0pGF;;AUvpGA,iDAAA;AACA;EACE,wCAAA;AV0pGF;;AUvpGA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AV0pGF;AUxpGE;EACE,aAAA;AV0pGJ;;AUtpGA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVypGF;;AUtpGA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVypGF;;AUrpGA;EACE,oCAAA;EACA,yBAAA;AVwpGF;;AUrpGA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AVwpGF;;AUppGA;EACE,kCAAA;AVupGF;;AUppGA;EACE,6BAAA;AVupGF;;AUppGA;EACE,kCAAA;AVupGF;;AUppGA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVupGF;;AUnpGA,2BAAA;AAEA;EACE,SAAA;AVqpGF;;AUlpGA;EACE,WAAA;EACA,2BAAA;AVqpGF;AUnpGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AVqpGJ;AUlpGE;EACE,uBAAA;AVopGJ;AUjpGE;EACE,kBAAA;AVmpGJ;;AU/oGA;EACE,WAAA;EACA,2BAAA;AVkpGF;;AU/oGA;EACE,WAAA;EACA,gBAAA;AVkpGF;AUhpGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AVkpGJ;AU/oGE;EACE,uBAAA;AVipGJ;AU9oGE;EACE,kBAAA;AVgpGJ;;AU5oGA;EACE,WAAA;EACA,gBAAA;AV+oGF;AU7oGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AV+oGJ;AU5oGE;EACE,uBAAA;AV8oGJ;AU3oGE;EACE,kBAAA;AV6oGJ;;AUzoGA;EACE,WAAA;EACA,gBAAA;AV4oGF;AU1oGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AV4oGJ;AUzoGE;EACE,uBAAA;AV2oGJ;AUxoGE;EACE,kBAAA;AV0oGJ;;AUtoGA;EACE,aAAA;AVyoGF;;AUtoGA;EACE,2BAAA;AVyoGF;AUtoGI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AVwoGN;AUroGI;EACE,iBAAA;EACA,eAAA;AVuoGN;AUpoGI;EACE,mBAAA;AVsoGN;AUnoGI;EACE,2CAAA;AVqoGN;;AUhoGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AVmoGF;;AUhoGA;EACE,oBAAA;EACA,mBAAA;AVmoGF;AUjoGE;EACE,YAAA;EACA,WAAA;AVmoGJ;;AU9nGI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EVkoGJ;AACF;;AU/nGA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVkoGF;AUhoGE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EVmoGF;AACF;AUjoGE;EACE,8BAAA;AVmoGJ;;AU/nGA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVkoGF;AUhoGE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVmoGF;AACF;AUjoGE;EACE,8BAAA;AVmoGJ;;AU/nGA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVkoGF;AUhoGE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVmoGF;AACF;;AUhoGA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AVmoGF;;AUhoGA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AVmoGF;;AUjoGA;EACE,mDAAA;EACA,4CAAA;AVooGF;;AUjoGA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AVooGF;;AUloGA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AVqoGF;;AUnoGA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVsoGF;;AUpoGA;EACE,2BAAA;AVuoGF;;AUpoGE;EACE,YAAA;AVuoGJ;AUroGE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVuoGJ;AUpoGI;EACE,yBAAA;EACA,oCAAA;AVsoGN;AUloGE;EACE,uBAAA;AVooGJ;AUloGE;EACE,uBAAA;AVooGJ;AUloGE;EACE,uBAAA;AVooGJ;;AUhoGA;EACE;IACE,4BAAA;IACA,eAAA;EVmoGF;EUhoGA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EVkoGF;EU/nGA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EVioGF;EU/nGA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EVioGF;EU/nGA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EVioGF;AACF;AU9nGA;EACE;IACE,kBAAA;EVgoGF;EU9nGA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EVgoGF;EU7nGA;IACE,kBAAA;IACA,0BAAA;EV+nGF;EU7nGA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EV+nGF;EU7nGE;IACF,kBAAA;IACE,0BAAA;EV+nGF;AACF;AU5nGA;EACE;IACE,UAAA;EV8nGF;AACF;AU3nGA;EACE,wCAAA;AV6nGF;;AU1nGA;EACE;IACE,iBAAA;IACA,8CAAA;EV6nGF;AACF;AU1nGA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AV4nGF;AU1nGE;EACE,sBAAA;AV4nGJ;;AUxnGA;EACE,wBAAA;AV2nGF;;AUznGA;EACE,qBAAA,EAAA,wCAAA;AV4nGF;;AU1nGA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AV6nGF;AU3nGE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AV4nGJ;AU1nGI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AV4nGN;AUznGI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AV2nGN;AUznGI;EApBF;IAqBI,WAAA;IACA,cAAA;EV4nGJ;AACF;AUznGE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AV2nGJ;AUznGI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AV2nGN;AUvnGE;EACE,iBAAA;EACA,uBAAA;AVynGJ;AUtnGI;EADF;IAEI,eAAA;EVynGJ;AACF;AUtnGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AVwnGJ;AUrnGE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AVunGJ;AUrnGI;EACE,iBAAA;AVunGN;;AUlnGA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVqnGF;;AUlnGA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AVqnGF;;AUlnGA;EACE,qBAAA;AVqnGF;;AUlnGA;EACE,kCAAA;EACA,YAAA;AVqnGF;;AUlnGA;EACE,kCAAA;EACA,YAAA;AVqnGF;;AUnnGA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AVqnGF;;AUjnGA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AVonGF;;AUlnGA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AVqnGF;AUnnGE;EACE,WAAA;AVqnGJ;AUlnGE;EACE;IACE,aAAA;EVonGJ;AACF;;AUhnGA;EACE,aAAA;EACA,mBAAA;AVmnGF;AUjnGE;EACE,WAAA;AVmnGJ;AUhnGE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AVknGJ;AU/mGE;EACE,uBAAA;AVinGJ;AU9mGE;EACE,uBAAA;AVgnGJ;;AU5mGA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AV+mGF;;AU5mGA;EACE,uBAAA;AV+mGF;;AU5mGA;EACE,aAAA;EACA,eAAA;AV+mGF;AU7mGE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AV+mGJ;;AU3mGA;EACE,gBAAA;EACA,kBAAA;AV8mGF;;AU1mGA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AV6mGF;;AUzmGE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AV4mGJ;;AUvmGE;EACE,mCAAA;AV0mGJ;AUvmGE;EACE,wBAAA;EACA,kBAAA;AVymGJ;;AUpmGE;EACE,kCAAA;AVumGJ;AUpmGE;EACE,uBAAA;EACA,kBAAA;AVsmGJ;;AUlmGA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AVqmGF;AUnmGE;EACE,sCAAA;EACA,+CAAA;AVqmGJ;;AUjmGA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVomGF;;AUjmGA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVomGF;;AUjmGA;EAEE,qBAAA;AVmmGF;;AU5lGA;EAEE,cAAA;AV8lGF;;AU3lGA;EACM,2BAAA;AV8lGN;;AU5lGA;EACE,2BAAA;AV+lGF;;AU7lGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AVgmGF;;AU7lGA;EACE,aAAA;EACA,iBAAA;AVgmGF;;AU7lGA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AVgmGF;AU9lGE;EACE,kBAAA;AVgmGJ;;AU5lGA;EACE,kBAAA;EACA,kBAAA;AV+lGF;;AU7lGA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AV+lGF;AU7lGE;EACE,gBAAA;AV+lGJ;AU7lGE;EACE,WAAA;AV+lGJ;;AU3lGA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AV8lGF;;AU3lGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AV8lGF;;AU3lGA;EACE,sBAAA;EACA,YAAA;AV8lGF;;AU3lGA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AV8lGF;;AU5lGA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AV+lGF;;AU7lGA;EACE,iCAAA;AVgmGF;;AU9lGA;EACE,sBAAA;AVimGF;;AU/lGA;EACE,iDAAA;EACA,mDAAA;AVkmGF;;AU/lGE;EACE,8BAAA;AVkmGJ;;AU9lGE;EACE,8BAAA;AVimGJ;;AU9lGA;EACE,uBAAA;AVimGF;;AU/lGA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AVimGF;;AU/lGA;EACE,6BAAA;EACA,kBAAA;AVkmGF;;AUhmGA;EACE,oCAAA;AVmmGF;;AUjmGA;EACE,kCAAA;AVomGF;;AUjmGE;EADF;IAEI,WAAA;EVqmGF;AACF;;AUlmGA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AVqmGF;;AUjmGE;EACE,qBAAA;AVomGJ;AUzlGA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AV2lGJ;;AUzlGA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AV4lGJ;;AUzlGA;EACE,2BAAA;AV4lGF;;AUxlGE;EADF;IAEI,wBAAA;EV4lGF;AACF;;AU1lGA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AV6lGF;;AU1lGA;EAAO,iBAAA;AV8lGP;;AU7lGA;EAAO,uBAAA;AVimGP;;AUhmGA;EAAO,sBAAA;AVomGP;;AUnmGA;EAAO,oBAAA;AVumGP;;AUtmGA;EAAO,sBAAA;AV0mGP;;AUzmGA;EAAO,oBAAA;AV6mGP;;AU1mGA;EAAQ,wBAAA;AV8mGR;;AU7mGA;EAAQ,8BAAA;AVinGR;;AUhnGA;EAAQ,6BAAA;AVonGR;;AUnnGA;EAAQ,2BAAA;AVunGR;;AUtnGA;EAAQ,6BAAA;AV0nGR;;AUznGA;EAAQ,2BAAA;AV6nGR;;AU1nGA;EAAQ,qBAAA;AV8nGR;;AU7nGA;EAAQ,2BAAA;AVioGR;;AUhoGA;EAAQ,0BAAA;AVooGR;;AUnoGA;EAAQ,wBAAA;AVuoGR;;AUtoGA;EAAQ,0BAAA;AV0oGR;;AUzoGA;EAAQ,wBAAA;AV6oGR;;AU5oGA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AV+oGF;;AU5oGA;EAAS,mBAAA;EAAqB,oBAAA;AVipG9B;;AUhpGA;EAAS,oBAAA;EAAsB,qBAAA;AVqpG/B;;AUppGA;EAAS,aAAA;EAAe,cAAA;AVypGxB;;AUxpGA;EAAS,oBAAA;EAAsB,qBAAA;AV6pG/B;;AU5pGA;EAAS,oBAAA;EAAsB,qBAAA;AViqG/B;;AUhqGA;EAAS,aAAA;EAAe,cAAA;AVqqGxB;;AUpqGA;EAAS,oBAAA;EAAsB,qBAAA;AVyqG/B;;AUxqGA;EAAS,oBAAA;EAAsB,qBAAA;AV6qG/B;;AU5qGA;EAAS,aAAA;EAAe,cAAA;AVirGxB;;AUhrGA;EAAU,oBAAA;EAAsB,qBAAA;AVqrGhC;;AUprGA;EAAU,oBAAA;EAAsB,qBAAA;AVyrGhC;;AUxrGA;EAAU,aAAA;EAAe,cAAA;AV6rGzB;;AU3rGA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVgsGjC;EU/rGA;IAAY,oBAAA;IAAsB,qBAAA;EVmsGlC;EUlsGA;IAAY,aAAA;IAAe,cAAA;EVssG3B;EUrsGA;IAAY,oBAAA;IAAsB,qBAAA;EVysGlC;EUxsGA;IAAY,oBAAA;IAAsB,qBAAA;EV4sGlC;EU3sGA;IAAY,aAAA;IAAe,cAAA;EV+sG3B;EU9sGA;IAAY,oBAAA;IAAsB,qBAAA;EVktGlC;EUjtGA;IAAY,oBAAA;IAAsB,qBAAA;EVqtGlC;EUptGA;IAAY,aAAA;IAAe,cAAA;EVwtG3B;EUvtGA;IAAa,oBAAA;IAAsB,qBAAA;EV2tGnC;EU1tGA;IAAa,oBAAA;IAAsB,qBAAA;EV8tGnC;EU7tGA;IAAa,aAAA;IAAe,cAAA;EViuG5B;AACF;AU/tGA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVmuGjC;EUluGA;IAAY,oBAAA;IAAsB,qBAAA;EVsuGlC;EUruGA;IAAY,aAAA;IAAe,cAAA;EVyuG3B;EUxuGA;IAAY,oBAAA;IAAsB,qBAAA;EV4uGlC;EU3uGA;IAAY,oBAAA;IAAsB,qBAAA;EV+uGlC;EU9uGA;IAAY,aAAA;IAAe,cAAA;EVkvG3B;EUjvGA;IAAY,oBAAA;IAAsB,qBAAA;EVqvGlC;EUpvGA;IAAY,oBAAA;IAAsB,qBAAA;EVwvGlC;EUvvGA;IAAY,aAAA;IAAe,cAAA;EV2vG3B;EU1vGA;IAAa,oBAAA;IAAsB,qBAAA;EV8vGnC;EU7vGA;IAAa,oBAAA;IAAsB,qBAAA;EViwGnC;EUhwGA;IAAa,cAAA;IAAgB,eAAA;EVowG7B;AACF;AUlwGA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVswGjC;EUrwGA;IAAY,oBAAA;IAAsB,qBAAA;EVywGlC;EUxwGA;IAAY,aAAA;IAAe,cAAA;EV4wG3B;EU3wGA;IAAY,oBAAA;IAAsB,qBAAA;EV+wGlC;EU9wGA;IAAY,oBAAA;IAAsB,qBAAA;EVkxGlC;EUjxGA;IAAY,aAAA;IAAe,cAAA;EVqxG3B;EUpxGA;IAAY,oBAAA;IAAsB,qBAAA;EVwxGlC;EUvxGA;IAAY,oBAAA;IAAsB,qBAAA;EV2xGlC;EU1xGA;IAAY,aAAA;IAAe,cAAA;EV8xG3B;EU7xGA;IAAa,oBAAA;IAAsB,qBAAA;EViyGnC;EUhyGA;IAAa,oBAAA;IAAsB,qBAAA;EVoyGnC;EUnyGA;IAAa,aAAA;IAAe,cAAA;EVuyG5B;AACF;AUryGA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVyyGjC;EUxyGA;IAAY,oBAAA;IAAsB,qBAAA;EV4yGlC;EU3yGA;IAAY,aAAA;IAAe,cAAA;EV+yG3B;EU9yGA;IAAY,oBAAA;IAAsB,qBAAA;EVkzGlC;EUjzGA;IAAY,oBAAA;IAAsB,qBAAA;EVqzGlC;EUpzGA;IAAY,aAAA;IAAe,cAAA;EVwzG3B;EUvzGA;IAAY,oBAAA;IAAsB,qBAAA;EV2zGlC;EU1zGA;IAAY,oBAAA;IAAsB,qBAAA;EV8zGlC;EU7zGA;IAAY,aAAA;IAAe,cAAA;EVi0G3B;EUh0GA;IAAa,oBAAA;IAAsB,qBAAA;EVo0GnC;EUn0GA;IAAa,oBAAA;IAAsB,qBAAA;EVu0GnC;EUt0GA;IAAa,aAAA;IAAe,cAAA;EV00G5B;AACF;AUx0GA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EV40GlC;EU30GA;IAAa,oBAAA;IAAsB,qBAAA;EV+0GnC;EU90GA;IAAa,aAAA;IAAe,cAAA;EVk1G5B;EUj1GA;IAAa,oBAAA;IAAsB,qBAAA;EVq1GnC;EUp1GA;IAAa,oBAAA;IAAsB,qBAAA;EVw1GnC;EUv1GA;IAAa,aAAA;IAAe,cAAA;EV21G5B;EU11GA;IAAa,oBAAA;IAAsB,qBAAA;EV81GnC;EU71GA;IAAa,oBAAA;IAAsB,qBAAA;EVi2GnC;EUh2GA;IAAa,aAAA;IAAe,cAAA;EVo2G5B;EUn2GA;IAAc,oBAAA;IAAsB,qBAAA;EVu2GpC;EUt2GA;IAAc,oBAAA;IAAsB,qBAAA;EV02GpC;EUz2GA;IAAc,aAAA;IAAe,cAAA;EV62G7B;AACF;AU52GA;EACE,0BAAA;AV82GF;;AU52GA;EACE,iBAAA;AV+2GF;;AU72GA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AVg3GJ;;AU72GA;EACI,uBAAA;AVg3GJ;;AU72GA;EACI,aAAA;AVg3GJ;;AU72GA;EAEI,gCAAA;EACA,oCAAA;AV+2GJ;;AA73IA;EACE,UAAA;AAg4IF;AA93IE;EAHF;IAII,UAAA;IACA,iBAAA;EAi4IF;AACF;;AA93IA;EACE,aAAA;AAi4IF;AA/3IE;EAHF;IAII,sBAAA;EAk4IF;AACF;;AA/3IA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAk4IF;;AA/3IA;EACE,iBAAA;EACA,eAAA;AAk4IF;;AA/3IA;EACE,WAAA;EAEA,oBAAA;EACA,eAAA;AAi4IF;AA/3IE;EANF;IAOI,YAAA;EAk4IF;AACF;AAh4IE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AAk4IJ;AAh4II;EALF;IAMI,YAAA;EAm4IJ;AACF;AAh4IE;EACE,WAAA;EACA,OAAA;EACA,gBAAA;AAk4IJ;AAj4II;EAJF;IAKI,WAAA;EAo4IJ;AACF;AAh4IE;EACE,aAAA;EACA,uBAAA;AAk4IJ;AAh4II;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;AAk4IN;AAh4IM;EAPF;IAQI,WAAA;EAm4IN;AACF;AA/3IE;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAi4IJ;AA/3II;EAZF;IAaI,gBAAA;IACA,0BAAA;IACA,WAAA;IACA,YAAA;EAk4IJ;AACF;AAh4II;EACE,8BAAA;AAk4IN;AA93IE;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAg4IJ;AA93II;EAZF;IAaI,gBAAA;IACA,WAAA;IACA,YAAA;EAi4IJ;AACF;AA/3II;EACE,8BAAA;AAi4IN;AA73IE;EACE,kBAAA;EACA,sBAAA;AA+3IJ;AA53IE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AA83IJ;AA53II;EANF;IAOI,gBAAA;EA+3IJ;AACF;AA73II;EACE,kBAAA;EACA,kBAAA;AA+3IN;AA33IE;EACE,sBAAA;AA63IJ;AA13IE;EACE,kBAAA;EACA,sBAAA;AA43IJ;AAz3IE;EACE,sBAAA;AA23IJ;AAx3IE;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;AA03IJ;AAv3IE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAy3IJ;AAv3II;EACE,eAAA;AAy3IN;AAt3II;EATF;IAUI,gBAAA;IACA,mBAAA;IACA,iBAAA;EAy3IJ;AACF;AAt3IE;EAtJF;IAuJI,mBAAA;IACA,eAAA;IACA,WAAA;EAy3IF;AACF;AAv3IE;EA5JF;IA6JI,mBAAA;IACA,eAAA;EA03IF;AACF;AAx3IE;EAjKF;IAkKI,mBAAA;IACA,eAAA;EA23IF;AACF;AAz3IE;EAtKF;IAuKI,mBAAA;IACA,eAAA;EA43IF;AACF;;AAz3IA;EACE,eAAA;AA43IF;;AAxzIA;EACE,8BAAA;EACA,gDAAA;AA2zIF;;AAxzIA;EACE,mBAAA;EACA,wDAAA;AA2zIF;;AAxzIA;EACE,8BAAA;EACA,6CAAA;AA2zIF;;AAxzIA;EACE,2BAAA;EACA,6BAAA;EAEA,gBAAA;AA0zIF;;AAvzIA;EACE,wBAAA;AA0zIF;;AAvzIA,2BAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,eAAA;EACA,kDAAA;AA0zIF;;AAvzIA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA0zIF;AAxzIE;EACE,UAAA;AA0zIJ;AAvzIE;EACE,WAAA;AAyzIJ;AAtzIE;EACE,UAAA;AAwzIJ;AArzIE;EACE,eAAA;EACA,iBAAA;AAuzIJ;;AAnzIA;EACE,iBAAA;AAszIF;;AAnzIA;EACE,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,4BAAA;AAszIF;;AAnzIA;EACE,6CAAA;EACA,sBAAA;EACA,6CAAA;AAszIF;;AAnzIA;EACE,+CAAA;EACA,YAAA;EACA,+CAAA;EACA,mBAAA;AAszIF;;AAnzIA;EACE,wCAAA;EACA,kCAAA;EACA,6CAAA;AAszIF;;AAnzIA;EACE;IACE,aAAA;IACA,sBAAA;EAszIF;EApzIE;IACE,WAAA;EAszIJ;EAlzIA;IACE,OAAA;IACA,2BAAA;EAozIF;AACF","sourcesContent":["@import \"src/styles\";\n\n.container {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n\n  .header {\n    h2 {\n      font-size: 1.2rem;\n    }\n\n    .row {\n      width: 100%;\n      display: flex;\n      align-items: baseline;\n      justify-content: space-between;\n\n      .mat-mdc-form-field {\n        width: 80%;\n      }\n\n      button {\n        padding: 0.5rem 2rem;\n        background-color: rgba(174, 15, 10, 1);\n        color: #fff;\n        border: none;\n        border-radius: 1rem;\n      }\n    }\n  }\n\n  .entitie-filters {\n    width: 100%;\n\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n  }\n\n  table {\n    min-height: 20vh;\n  }\n  .buttons {\n    margin-top: 1rem;\n    padding-bottom: 1rem;\n    display: flex;\n\n    justify-content: center;\n\n    @media (max-width: 767px) {\n      flex-direction: column;\n    }\n\n    button:first-of-type {\n      margin-right: 10px;\n    }\n  }\n}\n\n@import \"src/styles\";\n\n.field-width {\n  width: 70%;\n\n  @media (max-width: 767px) {\n    width: 90%;\n    margin-left: 15px;\n  }\n}\n\n.login-container {\n  display: flex;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n}\n\n.form-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  height: 92vh;\n  width: 100%;\n}\n\n.bold-font {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.login-form {\n  width: 100%;\n  // height: 100%;\n  margin-bottom: 10rem;\n  padding: 0 8rem;\n\n  @media (max-width: 767px) {\n    height: 92vh;\n  }\n\n  form {\n    height: inherit;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 767px) {\n      height: 92vh;\n    }\n  }\n\n  .fields {\n    width: 100%;\n    flex: 1;\n    min-height: 55vh;\n    @media (max-width: 767px) {\n      width: 100%;\n      // min-height: 55%;\n    }\n  }\n\n  .line {\n    display: flex;\n    justify-content: center;\n\n    hr {\n      border: none;\n      height: 2px;\n      background-color: #bdbcbc;\n      width: 80%;\n      border-radius: 5px;\n\n      @media (max-width: 767px) {\n        width: 100%;\n      }\n    }\n  }\n\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n    background: map-get($primary-color, 500);\n    color: white;\n    width: 14rem;\n    border-radius: 10px;\n    padding: 0.75rem 0;\n    border: none;\n    font-weight: bold;\n    margin-top: 2.5rem;\n    align-self: center;\n    cursor: pointer;\n\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      margin-right: 0 !important;\n      width: 100%;\n      height: 45px;\n    }\n\n    &[disabled] {\n      background: map-get($medium-color, 700);\n    }\n  }\n\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {\n    background: white;\n    color: map-get($primary-color, 500);\n    width: 14rem;\n    border-radius: 10px;\n    padding: 0.75rem 0;\n    border: 2px solid map-get($primary-color, 500);\n    font-weight: bold;\n    margin-top: 2.5rem;\n    align-self: center;\n    cursor: pointer;\n\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      width: 100%;\n      height: 45px;\n    }\n\n    &[disabled] {\n      background: map-get($medium-color, 700);\n    }\n  }\n\n  .name-form-field {\n    text-align: center;\n    color: map-get($dark-color, 300);\n  }\n\n  .invalid {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 15px;\n\n    @media (max-width: 767px) {\n      margin-left: 5px;\n    }\n\n    .icon-error {\n      padding-left: 10px;\n      padding-right: 8px;\n    }\n  }\n\n  .login-field-prefix {\n    color: map-get($dark-color, 300);\n  }\n\n  .email-form-field {\n    text-align: center;\n    color: map-get($dark-color, 300);\n  }\n\n  .email-field-prefix {\n    color: map-get($dark-color, 300);\n  }\n\n  .email-field-prefix-invalid {\n    padding-top: 7px;\n    padding-bottom: 15px;\n    color: map-get($dark-color, 300);\n  }\n\n  h6 {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    mat-icon {\n      cursor: pointer;\n    }\n\n    @media (max-width: 767px) {\n      margin-top: 2rem;\n      margin-bottom: 2rem;\n      margin-left: 15px;\n    }\n  }\n\n  @media (max-width: 767px) {\n    margin-bottom: 1rem;\n    padding: 0 1rem;\n    width: 100%;\n  }\n\n  @media (min-width: 768px) and (max-width: 1024px) {\n    margin-bottom: 3rem;\n    padding: 0 2rem;\n  }\n\n  @media (min-width: 1025px) and (max-width: 1366px) {\n    margin-bottom: 4rem;\n    padding: 0 4rem;\n  }\n\n  @media (min-width: 1367px) {\n    margin-bottom: 5rem;\n    padding: 0 4rem;\n  }\n}\n\n.mat-expansion-panel-header-title {\n  font-size: 1rem;\n}\n\n// .side-panel {\n//   background: linear-gradient(180deg,\n//       rgba(174, 15, 10, 0.7) 60.83%,\n//       rgba(72, 6, 4, 0.7) 113.08%),\n//     url(\"../../../../assets/login/background.jpg\");\n//   background-size: cover;\n//   width: 50%;\n//   border-radius: 0 30px 30px 0;\n//   display: flex;\n//   flex-direction: column;\n\n//   @media (max-width: 767px) {\n//     width: 100%;\n//     border-radius: 0 0 30px 30px;\n//   }\n\n//   .logo-infra {\n//     max-width: 55%;\n//     align-self: center;\n//     margin-top: 6rem;\n\n//     @media (max-width: 320px) {\n//       max-width: 65%;\n//     }\n\n//     @media (min-width: 321px) and (max-width: 425px) {\n//       max-width: 60%;\n//     }\n\n//     @media (max-width: 767px) {\n//       margin-top: 2rem;\n//     }\n//   }\n\n//   .welcome-text {\n//     color: white;\n//     align-self: center;\n//     margin-top: 4rem;\n//     padding: 0 1rem;\n//     line-height: 39px;\n//     font-size: 2.5rem;\n\n//     @media (max-width: 425px) {\n//       font-size: 1.25rem;\n//       line-height: 24px;\n//       text-align: center;\n//       margin-top: 2.5rem;\n//       margin-bottom: 2rem;\n//     }\n\n//     @media (min-width: 426px) and (max-width: 767px) {\n//       font-size: 1.5rem;\n//       line-height: 28px;\n//       margin-top: 3rem;\n//       text-align: center;\n//       margin-bottom: 2rem;\n//     }\n\n//     @media (min-width: 768px) and (max-width: 1024px) {\n//       font-size: 1.85rem;\n//       line-height: 32px;\n//     }\n//   }\n// }\n\n.panel-with-border .mat-expansion-panel-header {\n  border-bottom: 1px solid black;\n  /* Estilo da borda quando o painel está aberto */\n}\n\n.panel-with-border .mat-expansion-panel-header.mat-expanded {\n  border-bottom: none;\n  /* Remove a borda inferior quando o painel está aberto */\n}\n\n.panel-with-border.mat-expansion-panel {\n  border-bottom: 1px solid black;\n  /* Estilo da borda do painel quando fechado */\n}\n\n.mat-expansion-panel {\n  box-shadow: none !important;\n  background-color: transparent;\n  // border-bottom: 1px solid;\n  border-radius: 0;\n}\n\n.mat-mdc-select-arrow-wrapper {\n  display: none !important;\n}\n\n/* Estilizar o novo ícone */\n.custom-select-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  font-size: 24px;\n  /* Ajuste o tamanho do ícone conforme necessário */\n}\n\n.form-group {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .mat-mdc-form-field {\n    width: 45%;\n  }\n\n  .first-input {\n    width: 100%;\n  }\n\n  .bank-form-field {\n    width: 70%;\n  }\n\n  p {\n    margin-top: 0px;\n    font-size: 1.1rem;\n  }\n}\n\n.btn-primary {\n  margin: 0rem 1rem;\n}\n\n.btn-exclude {\n  border: 2px solid rgba(112, 111, 111, 1) !important;\n  background-color: transparent !important;\n  color: rgba(112, 111, 111, 1) !important;\n  font-weight: bold !important;\n}\n\n.btn-submit {\n  background-color: rgba(174, 15, 10, 1) !important;\n  color: #fff !important;\n  border: 2px solid rgba(174, 15, 10, 1) !important;\n}\n\n.disabled-button {\n  background-color: rgba(112, 111, 111, 1) !important;\n  color: white;\n  border: 2px solid rgba(112, 111, 111, 1) !important;\n  cursor: not-allowed;\n}\n\n.btn-back {\n  background-color: transparent !important;\n  color: rgba(174, 15, 10, 1) !important;\n  border: 2px solid rgba(174, 15, 10, 1) !important;\n}\n\n@media (max-width: 500px) {\n  .form-group {\n    display: flex;\n    flex-direction: column;\n\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n  }\n\n  .fields {\n    flex: 1;\n    min-height: auto !important;\n  }\n}\n","@use '@angular/cdk';\n\n@mixin ripple() {\n  // The host element of an mat-ripple directive should always have a position of \"absolute\" or\n  // \"relative\" so that the ripples inside are correctly positioned relatively to the container.\n  .mat-ripple {\n    overflow: hidden;\n\n    // By default, every ripple container should have position: relative in favor of creating an\n    // easy API for developers using the MatRipple directive.\n    position: relative;\n\n    // Promote containers that have ripples to a new layer. We want to target `:not(:empty)`,\n    // because we don't want all ripple containers to have their own layer since they're used in a\n    // lot of places and the layer is only relevant while animating. Note that ideally we'd use\n    // the `contain` property here (see #13175), because `:empty` can be broken by having extra\n    // text inside the element, but it isn't very well supported yet.\n    &:not(:empty) {\n      transform: translateZ(0);\n    }\n  }\n\n  .mat-ripple.mat-ripple-unbounded {\n    overflow: visible;\n  }\n\n  .mat-ripple-element {\n    position: absolute;\n    border-radius: 50%;\n    pointer-events: none;\n\n    transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);\n\n    // We use a 3d transform here in order to avoid an issue in Safari where\n    // the ripples aren't clipped when inside the shadow DOM (see #24028).\n    transform: scale3d(0, 0, 0);\n\n    // In high contrast mode the ripple is opaque, causing it to obstruct the content.\n    @include cdk.high-contrast(active, off) {\n      display: none;\n    }\n  }\n}\n","/// Emits a CSS class, `.cdk-visually-hidden`. This class can be applied to an element\n/// to make that element visually hidden while remaining available to assistive technology.\n@mixin a11y-visually-hidden() {\n  .cdk-visually-hidden {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n\n    // This works around a Chrome bug that can cause the tab to crash when large amounts of\n    // non-English text get wrapped: https://bugs.chromium.org/p/chromium/issues/detail?id=1201444\n    white-space: nowrap;\n\n    // Avoid browsers rendering the focus ring in some cases.\n    outline: 0;\n\n    // Avoid some cases where the browser will still render the native controls (see #9049).\n    -webkit-appearance: none;\n    -moz-appearance: none;\n\n    // We need at least one of top/bottom/left/right in order to prevent cases where the\n    // absolute-positioned element is pushed down and can affect scrolling (see #24597).\n    // `left` was chosen here, because it's the least likely to break overrides where the\n    // element might have been positioned (e.g. `mat-checkbox`).\n    left: 0;\n\n    [dir='rtl'] & {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n/// @deprecated Use `a11y-visually-hidden`.\n@mixin a11y() {\n  @include a11y-visually-hidden;\n}\n\n/// Emits the mixin's content nested under `$selector-context` if `$selector-context`\n/// is non-empty.\n/// @param {String} selector-context The selector under which to nest the mixin's content.\n@mixin _optionally-nest-content($selector-context) {\n  @if ($selector-context == '') {\n    @content;\n  }\n  @else {\n    #{$selector-context} {\n      @content;\n    }\n  }\n}\n\n/// Applies styles for users in high contrast mode. Note that this only applies\n/// to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n/// attribute, however Chrome handles high contrast differently.\n///\n/// @param {String} target Type of high contrast setting to target. Defaults to `active`, can be\n///     `white-on-black` or `black-on-white`.\n/// @param {String} encapsulation Whether to emit styles for view encapsulation. Values are:\n///     * `on` - works for `Emulated`, `Native`, and `ShadowDom`\n///     * `off` - works for `None`\n///     * `any` - works for all encapsulation modes by emitting the CSS twice (default).\n@mixin high-contrast($target: active, $encapsulation: 'any') {\n  @if ($target != 'active' and $target != 'black-on-white' and $target != 'white-on-black') {\n    @error 'Unknown cdk-high-contrast value \"#{$target}\" provided. ' +\n           'Allowed values are \"active\", \"black-on-white\", and \"white-on-black\"';\n  }\n\n  @if ($encapsulation != 'on' and $encapsulation != 'off' and $encapsulation != 'any') {\n    @error 'Unknown cdk-high-contrast encapsulation \"#{$encapsulation}\" provided. ' +\n           'Allowed values are \"on\", \"off\", and \"any\"';\n  }\n\n  // If the selector context has multiple parts, such as `.section, .region`, just doing\n  // `.cdk-high-contrast-xxx #{&}` will only apply the parent selector to the first part of the\n  // context. We address this by nesting the selector context under .cdk-high-contrast.\n  @at-root {\n    $selector-context: #{&};\n\n    @if ($encapsulation != 'on') {\n      // Note that if this selector is updated, the same change has to be made inside\n      // `_overlay.scss` which can't depend on this mixin due to some infrastructure limitations.\n      .cdk-high-contrast-#{$target} {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n\n    @if ($encapsulation != 'off') {\n      .cdk-high-contrast-#{$target} :host {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n  }\n}\n","// We want overlays to always appear over user content, so set a baseline\n// very high z-index for the overlay container, which is where we create the new\n// stacking context for all overlays.\n$overlay-container-z-index: 1000 !default;\n$overlay-z-index: 1000 !default;\n$overlay-backdrop-z-index: 1000 !default;\n\n// Background color for all of the backdrops\n$overlay-backdrop-color: rgba(0, 0, 0, 0.32) !default;\n\n// Default backdrop animation is based on the Material Design swift-ease-out.\n$backdrop-animation-duration: 400ms !default;\n$backdrop-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1) !default;\n\n/// Emits structural styles required for cdk/overlay to function.\n@mixin overlay() {\n  .cdk-overlay-container, .cdk-global-overlay-wrapper {\n    // Disable events from being captured on the overlay container.\n    pointer-events: none;\n\n    // The container should be the size of the viewport.\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n  }\n\n  // The overlay-container is an invisible element which contains all individual overlays.\n  .cdk-overlay-container {\n    position: fixed;\n    z-index: $overlay-container-z-index;\n\n    &:empty {\n      // Hide the element when it doesn't have any child nodes. This doesn't\n      // include overlays that have been detached, rather than disposed.\n      display: none;\n    }\n  }\n\n  // We use an extra wrapper element in order to use make the overlay itself a flex item.\n  // This makes centering the overlay easy without running into the subpixel rendering\n  // problems tied to using `transform` and without interfering with the other position\n  // strategies.\n  .cdk-global-overlay-wrapper {\n    display: flex;\n    position: absolute;\n    z-index: $overlay-z-index;\n  }\n\n  // A single overlay pane.\n  .cdk-overlay-pane {\n    // Note: it's important for this one to start off `absolute`,\n    // in order for us to be able to measure it correctly.\n    position: absolute;\n    pointer-events: auto;\n    box-sizing: border-box;\n    z-index: $overlay-z-index;\n\n    // For connected-position overlays, we set `display: flex` in\n    // order to force `max-width` and `max-height` to take effect.\n    display: flex;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  .cdk-overlay-backdrop {\n    // TODO(jelbourn): reuse sidenav fullscreen mixin.\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n\n    z-index: $overlay-backdrop-z-index;\n    pointer-events: auto;\n    -webkit-tap-highlight-color: transparent;\n    transition: opacity $backdrop-animation-duration $backdrop-animation-timing-function;\n    opacity: 0;\n\n    &.cdk-overlay-backdrop-showing {\n      opacity: 1;\n\n      // Note that we can't import and use the `high-contrast` mixin from `_a11y.scss`, because\n      // this file will be copied to the top-level `cdk` package when putting together the files\n      // for npm. Any relative import paths we use here will become invalid once the file is copied.\n      .cdk-high-contrast-active & {\n        // In high contrast mode the rgba background will become solid\n        // so we need to fall back to making it opaque using `opacity`.\n        opacity: 0.6;\n      }\n    }\n  }\n\n  .cdk-overlay-dark-backdrop {\n    background: $overlay-backdrop-color;\n  }\n\n  .cdk-overlay-transparent-backdrop {\n    // Define a transition on the visibility so that the `transitionend` event can fire immediately.\n    transition: visibility 1ms linear, opacity 1ms linear;\n    visibility: hidden;\n    opacity: 1;\n\n    // Note: as of Firefox 57, having the backdrop be `background: none` will prevent it from\n    // capturing the user's mouse scroll events. Since we also can't use something like\n    // `rgba(0, 0, 0, 0)`, we work around the inconsistency by not setting the background at\n    // all and using `opacity` to make the element transparent.\n    &.cdk-overlay-backdrop-showing {\n      opacity: 0;\n      visibility: visible;\n    }\n  }\n\n  .cdk-overlay-backdrop-noop-animation {\n    transition: none;\n  }\n\n  // Overlay parent element used with the connected position strategy. Used to constrain the\n  // overlay element's size to fit within the viewport.\n  .cdk-overlay-connected-position-bounding-box {\n    position: absolute;\n    z-index: $overlay-z-index;\n\n    // We use `display: flex` on this element exclusively for centering connected overlays.\n    // When *not* centering, a top/left/bottom/right will be set which overrides the normal\n    // flex layout.\n    display: flex;\n\n    // We use the `column` direction here to avoid some flexbox issues in Edge\n    // when using the \"grow after open\" options.\n    flex-direction: column;\n\n    // Add some dimensions so the element has an `innerText` which some people depend on in tests.\n    min-width: 1px;\n    min-height: 1px;\n  }\n\n  // Used when disabling global scrolling.\n  .cdk-global-scrollblock {\n    position: fixed;\n\n    // Necessary for the content not to lose its width. Note that we're using 100%, instead of\n    // 100vw, because 100vw includes the width plus the scrollbar, whereas 100% is the width\n    // that the element had before we made it `fixed`.\n    width: 100%;\n\n    // Note: this will always add a scrollbar to whatever element it is on, which can\n    // potentially result in double scrollbars. It shouldn't be an issue, because we won't\n    // block scrolling on a page that doesn't have a scrollbar in the first place.\n    overflow-y: scroll;\n  }\n}\n","// Structural styles for the autosize text fields.\n@mixin text-field-autosize() {\n  // Remove the resize handle on autosizing textareas, because whatever height\n  // the user resized to will be overwritten once they start typing again.\n  textarea.cdk-textarea-autosize {\n    resize: none;\n  }\n\n  // This class is temporarily applied to the textarea when it is being measured. It is immediately\n  // removed when measuring is complete. We use `!important` rules here to make sure user-specified\n  // rules do not interfere with the measurement.\n  textarea.cdk-textarea-autosize-measuring {\n    @include _autosize-measuring-base;\n    height: auto !important;\n    overflow: hidden !important;\n  }\n\n  // Similar to the `cdk-textarea-autosize-measuring` class, but only applied on Firefox. We need\n  // to use this class, because Firefox has a bug where changing the `overflow` breaks the user's\n  // ability to undo/redo what they were typing (see #16629). This class is only scoped to Firefox,\n  // because the measurements there don't seem to be affected by the `height: 0`, whereas on other\n  // browsers they are, e.g. Chrome detects longer text and IE does't resize back to normal.\n  // Identical issue report: https://bugzilla.mozilla.org/show_bug.cgi?id=448784\n  textarea.cdk-textarea-autosize-measuring-firefox {\n    @include _autosize-measuring-base;\n    height: 0 !important;\n  }\n}\n\n// Core styles that enable monitoring autofill state of text fields.\n@mixin text-field-autofill() {\n  // Keyframes that apply no styles, but allow us to monitor when an text field becomes autofilled\n  // by watching for the animation events that are fired when they start. Note: the /*!*/ comment is\n  // needed to prevent LibSass from stripping the keyframes out.\n  // Based on: https://medium.com/@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7\n  @keyframes cdk-text-field-autofill-start {/*!*/}\n  @keyframes cdk-text-field-autofill-end {/*!*/}\n\n  .cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms;\n  }\n\n  .cdk-text-field-autofill-monitored:not(:-webkit-autofill) {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-end 0s 1ms;\n  }\n}\n\n@mixin _autosize-measuring-base {\n  // Having 2px top and bottom padding seems to fix a bug where Chrome gets an incorrect\n  // measurement. We just have to account for it later and subtract it off the final result.\n  padding: 2px 0 !important;\n  box-sizing: content-box !important;\n}\n\n// Used to generate UIDs for keyframes used to change the text field autofill styles.\n$autofill-color-frame-count: 0;\n\n// Mixin used to apply custom background and foreground colors to an autofilled text field.\n// Based on: https://stackoverflow.com/questions/2781549/\n// removing-input-background-colour-for-chrome-autocomplete#answer-37432260\n@mixin text-field-autofill-color($background, $foreground:'') {\n  @keyframes cdk-text-field-autofill-color-#{$autofill-color-frame-count} {\n    to {\n      background: $background;\n      @if $foreground != '' { color: $foreground; }\n    }\n  }\n\n  &:-webkit-autofill {\n    animation: cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  &.cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay for cdk-text-field-autofill-start, or the animationstart\n    // event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms,\n               cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  $autofill-color-frame-count: $autofill-color-frame-count + 1 !global;\n}\n\n// @deprecated Use `autosize` and `autofill` instead.\n@mixin text-field {\n  @include text-field-autosize();\n  @include text-field-autofill();\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use '@angular/cdk';\n@use '../style/layout-common';\n@use '../theming/theming';\n\n// Private sass variables that will be used as reference throughout component stylesheets.\n$default-border-width: 3px;\n$default-border-style: solid;\n$default-border-color: transparent;\n$default-border-radius: 4px;\n\n// Mixin that renders the focus indicator structural styles.\n@mixin structural-styling($prefix) {\n  .#{$prefix}-focus-indicator {\n    position: relative;\n\n    &::before {\n      @include layout-common.fill();\n      box-sizing: border-box;\n      pointer-events: none;\n      display: var(--#{$prefix}-focus-indicator-display, none); // Hide the indicator by default.\n      border: var(\n          --#{$prefix}-focus-indicator-border-width,\n          #{$default-border-width}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-style,\n          #{$default-border-style}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-color,\n          #{$default-border-color}\n        );\n      border-radius: var(\n        --#{$prefix}-focus-indicator-border-radius,\n        #{$default-border-radius}\n      );\n    }\n\n    // By default, render the focus indicator when the focus indicator host element takes focus.\n    // Defining a pseudo element's content will cause it to render.\n    &:focus::before {\n      content: '';\n    }\n  }\n\n  // Enable the indicator in high contrast mode.\n  @include cdk.high-contrast(active, off) {\n    @include customize-focus-indicators((display: block), $prefix);\n  }\n}\n\n// Generates CSS variable declarations from a map.\n@mixin _output-variables($map) {\n  @each $key, $value in $map {\n    @if ($value) {\n      --#{$key}: #{$value};\n    }\n  }\n}\n\n// Mixin that dedups CSS variables for the strong-focus-indicators mixin.\n@mixin customize-focus-indicators($config, $prefix) {\n  $border-style: map.get($config, border-style);\n  $border-width: map.get($config, border-width);\n  $border-radius: map.get($config, border-radius);\n  $border-color: map.get($config, border-color);\n  $display: map.get($config, display);\n  $map: (\n    '#{$prefix}-focus-indicator-border-style': $border-style,\n    '#{$prefix}-focus-indicator-border-width': $border-width,\n    '#{$prefix}-focus-indicator-border-radius': $border-radius,\n    '#{$prefix}-focus-indicator-border-color': $border-color,\n    '#{$prefix}-focus-indicator-display': $display,\n  );\n\n  @if (&) {\n    @include _output-variables($map);\n  }\n  @else {\n    // We use `html` here instead of `:root`, because the\n    // latter causes some issues with internal tooling.\n    html {\n      @include _output-variables($map);\n    }\n  }\n}\n\n@mixin strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat');\n}\n\n@mixin mdc-strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat-mdc');\n}\n\n@mixin strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat');\n  }\n}\n\n@mixin strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n\n@mixin mdc-strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat-mdc');\n  }\n}\n\n@mixin mdc-strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-mdc-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include mdc-strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n","// This mixin ensures an element spans to fill the nearest ancestor with defined positioning.\n@mixin fill {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n}\n","/* \n\tColors values \n\t300 = tint\n\t500 = default\n\t700 = shade\n*/\n$primary-color: (\n  500: rgba(174, 15, 10, 1),\n  300: rgba(227, 6, 19, 1),\n  700: rgba(228, 173, 181, 1),\n  contrast: (500: white,\n    300: white,\n    700: black,\n  ),\n);\n$secondary-color: (\n  500: rgba(0, 87, 158, 1),\n  300: rgba(51, 125, 192, 1),\n  700: rgba(0, 59, 109, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$warning-color: (\n  500: rgba(255, 196, 9, 1),\n  300: rgba(255, 202, 34, 1),\n  700: rgba(224, 172, 8, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);\n\n$danger-color: (\n  500: rgba(235, 68, 90, 1),\n  300: rgba(237, 87, 107, 1),\n  700: rgba(207, 60, 79, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$success-color: (\n  500: rgba(45, 211, 111, 1),\n  300: rgba(66, 215, 125, 1),\n  700: rgba(40, 186, 98, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$dark-color: (\n  500: rgba(34, 36, 40, 1),\n  300: rgba(60, 60, 59, 1),\n  700: rgba(87, 87, 86, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$medium-color: (\n  500: rgba(112, 111, 111, 1),\n  300: rgba(135, 135, 135, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$light-color: (\n  500: rgba(227, 227, 227, 1),\n  300: rgba(245, 246, 249, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);","@import \"variables\";\n\nbody {\n  font-family: \"Barlow\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 600;\n}\n\nh1 {\n  font-size: 64px;\n  line-height: 78px;\n}\n\nh2 {\n  font-size: 56px;\n  line-height: 68px;\n}\n\nh3 {\n  font-size: 48px;\n  line-height: 58px;\n}\n\nh4 {\n  font-size: 40px;\n  line-height: 48px;\n}\n\nh5 {\n  font-size: 32px;\n  line-height: 39px;\n}\n\nh6 {\n  font-size: 24px;\n  line-height: 29px;\n}\n\na {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n  color: map-get($primary-color, 500);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\ncaption {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n}\n\nth {\n  font-weight: 700;\n  cursor: pointer;\n}\n","$spacing-sizes: (\n  0: 0px,\n  1: 8px,\n  2: 16px,\n  3: 24px,\n  4: 32px,\n  5: 40px,\n  6: 48px,\n  7: 56px,\n  8: 64px,\n  9: 72px,\n  10: 80px,\n);\n\n@each $key, $size in $spacing-sizes {\n  .p-#{$key} {\n    padding: #{$size};\n  }\n  .pt-#{$key} {\n    padding-top: #{$size};\n  }\n  .pr-#{$key} {\n    padding-right: #{$size};\n  }\n  .pb-#{$key} {\n    padding-bottom: #{$size};\n  }\n  .pl-#{$key} {\n    padding-left: #{$size};\n  }\n  .px-#{$key} {\n    padding-left: #{$size};\n    padding-right: #{$size};\n  }\n  .py-#{$key} {\n    padding-top: #{$size};\n    padding-bottom: #{$size};\n  }\n\n  .m-#{$key} {\n    margin: #{$size};\n  }\n  .mt-#{$key} {\n    margin-top: #{$size};\n  }\n  .mr-#{$key} {\n    margin-right: #{$size};\n  }\n  .mb-#{$key} {\n    margin-bottom: #{$size};\n  }\n  .ml-#{$key} {\n    margin-left: #{$size};\n  }\n  .mx-#{$key} {\n    margin-left: #{$size};\n    margin-right: #{$size};\n  }\n  .my-#{$key} {\n    margin-top: #{$size};\n    margin-bottom: #{$size};\n  }\n}\n","@use \"@angular/material\" as mat;\n@include mat.core();\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\n@import \"theme/typography.scss\";\n@import \"theme/variables.scss\";\n@import \"theme/spacing\";\n@import url(\"https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\nhtml {\n  --mdc-outlined-text-field-focus-outline-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n  --mdc-outlined-text-field-focus-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-option-selected-state-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-datepicker-toggle-active-state-icon-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n\n  --mdc-filled-text-field-focus-active-indicator-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-sidenav-content-background-color: white !important;\n}\n\n/* You can add global styles to this file, and also import other style files */\n/* Angular 15 adds grey background on mat form components */\n/* below removes that background color */\n/* Manipulate initial background color*/\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n/*Manipulate background color on hover and focus*/\n.mat-mdc-form-field-focus-overlay {\n  background-color: transparent !important;\n}\n\n.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {\n  width: 0px;\n  padding-left: 6px;\n  padding-right: 6px;\n\n  span {\n    display: none;\n  }\n}\n\n/* Pagination menu */\n.g-bubble-container {\n  display: flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.g-bubble {\n  background-color: map-get($light-color, 300);\n  border-radius: 4px;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: map-get($dark-color, 500) !important;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.3s;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n  text-align: center;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n.g-bubble:hover {\n  background-color: map-get($light-color, 700);\n  color: map-get($light-color, 300);\n}\n\n.g-bubble__active {\n  background-color: map-get($primary-color, 300);\n  color: map-get($light-color, 500) !important;\n  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12),\n    0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);\n}\n\nmat-paginator {\n  background: transparent !important;\n}\n\n.mat-mdc-paginator-range-actions {\n  margin-right: 12px !important;\n}\n\n.mat-mdc-paginator-container {\n  justify-content: center !important;\n}\n\n.mat-mdc-paginator-navigation-next,\n.mat-mdc-paginator-navigation-previous {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: map-get($dark-color, 500) !important;\n  padding: 0 !important;\n  border-radius: 4px !important;\n  width: 34px !important;\n  height: 34px !important;\n  background-color: map-get($light-color, 300) !important;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n/* End of pagination menu */\n\nbody {\n  margin: 0;\n}\n\n.snackbar {\n  width: 50vw;\n  margin: 10px 0px !important;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snackbar-custom {\n  width: 50vw;\n  margin-top: 75px !important;\n}\n\n.snacbar-warning {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid #e0ac08;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-sucess {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid green;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-error {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid red;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.mat-mdc-menu-panel {\n  overflow: hidden !important;\n\n  .mat-mdc-menu-content {\n    .menu-header {\n      font-size: 12px;\n      padding: 1rem;\n      padding-bottom: 0.25rem;\n    }\n\n    .mat-mdc-menu-item {\n      margin-left: 1rem;\n      padding-left: 0;\n    }\n\n    .mat-mdc-menu-item:first-of-type {\n      margin-top: 0.75rem;\n    }\n\n    .mat-mdc-menu-item:not(:last-child) {\n      border-bottom: 1px solid map-get($light-color, 700);\n    }\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3000;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sort-icon-container {\n  display: inline-flex;\n  align-items: center;\n\n  mat-icon {\n    height: 1rem;\n    width: 1rem;\n  }\n}\napp-edit-contract{\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      margin-right: 0 !important;\n      width: 40% !important;\n      height: 45px;\n    }\n  }\n}\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($primary-color, 500);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    margin-right: 0 !important;\n    width: 40%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {\n  background: white;\n  color: map-get($primary-color, 500);\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: 2px solid map-get($primary-color, 500);\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($medium-color, 700);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n}\n\n/* \n  IONIC components\n*/\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\nion-item.no-padding-full {\n  --padding-end: 0;\n  --padding-start: 0;\n  --inner-padding-end: 0;\n  --inner-padding-start: 0;\n}\nion-checkbox {\n  --checkbox-background-checked: rgba(174, 15, 10, 1);\n  --border-color-checked: rgba(174, 15, 10, 1);\n}\n\nion-input.custom-input {\n  --border-color: rgba(135, 135, 135, 1);\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.custom-input-user {\n  --border-color: #EFEFEF;\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.width-full {\n  --border-color: #EFEFEF !important;\n  --padding-top: 5px;\n  --highlight-color: rgb(37, 19, 19);\n}\n.filter-panel {\n  max-width: 100vw !important;\n}\n.date-select-modal-filter {\n  .mdc-text-field {\n    height: 35px;\n  }\n  .mat-mdc-form-field-infix {\n    height: 35px;\n    min-height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .select-year {\n    .mat-mdc-text-field-wrapper {\n      background-color: #f4f4f4;\n      border: 1px solid rgb(189, 188, 188);\n    }\n  }\n\n  .mdc-notched-outline__leading {\n    border: none !important;\n  }\n  .mdc-notched-outline__notch {\n    border: none !important;\n  }\n  .mdc-notched-outline__trailing {\n    border: none !important;\n  }\n}\n\n@media (min-width: 1025px) {\n  .filter-panel {\n    max-height: 33rem !important;\n    min-width: 60vw;\n  }\n\n  .anotation-panel {\n    max-width: 30rem !important;\n    max-height: 30rem !important;\n    min-width: 50vw;\n  }\n\n  .historic-panel {\n    min-width: 49.5rem;\n    min-height: 35.625rem;\n    min-width: 50vw;\n  }\n  .segments-panel {\n    width: 72vw;\n    min-width: 760px;\n    max-width: 1100px !important;\n    max-height: 90vh !important;\n  }\n  .new-highway-modal-panel {\n    min-width: 49.5rem;\n    min-height: 23.625rem;\n    min-width: 50vw;\n  }\n}\n\n@media (max-width: 1024px) {\n  .btn-actions {\n    margin-right: 15px;\n  }\n  .filter-panel {\n    min-height: 30rem;\n    max-width: 100vw !important;\n    min-width: 90vw;\n  }\n\n  .historic-panel {\n    max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n  .segments-panel {\n    max-width: 90vw !important;\n    min-width: 90vw !important;\n    max-height: 90vh !important;\n  }\n    .new-highway-modal-panel {\n  max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .anotation-panel {\n    width: 90%;\n  }\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n@media (max-width: 1024px) {\n  .mat-mdc-form-field-label {\n    font-size: 0.8rem;\n    /* Tamanho de fonte para dispositivos móveis */\n  }\n}\n\n.button_cad {\n  background-color: map-get($primary-color, 500);\n  padding: 0.5rem 2rem;\n  border-radius: 0.5rem;\n  color: #fff;\n  font-style: none;\n  text-decoration: none;\n\n  mat-icon {\n    color: #fff !important;\n  }\n}\n\n::ng-deep.mat-mdc-card-header-text {\n  display: none !important;\n}\n.input-error {\n  border: 1px solid red; /* Ajuste o estilo conforme necessário */\n}\n.card-mobile {\n  min-height: 10rem;\n  margin: 1rem auto;\n  border: 1px solid #cdcdcd;\n\n  .mat-mdc-card-header {\n    width: 90%;\n    display: flex;\n    margin: auto;\n    // align-items: center;\n    justify-content: space-between;\n    padding: 0rem;\n\n    p {\n      font-weight: bolder;\n      font-size: 1.2rem;\n      text-transform: uppercase;\n    }\n\n    span,\n    .subtitle {\n      font-size: 1rem;\n      font-weight: normal;\n      color: #cdcdcd;\n    }\n    @media (max-width: 1024px) {\n      width: 100%;\n      margin: 0 16px;\n    }\n  }\n\n  .mat-mdc-card-footer {\n    margin: 1rem 0rem;\n    border-top: 1px solid black;\n    display: flex;\n    align-items: center;\n\n    button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n\n  .extension {\n    font-weight: bold;\n    color: map-get($primary-color, 500);\n  }\n  .formatAnotation {\n    @media (max-width: 1024px) {\n      padding: 0 16px;\n    }\n  }\n\n  .content-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .content-status {\n    width: 40%;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n\n    p {\n      font-weight: bold;\n    }\n  }\n}\n\n.card-mobile-empty {\n  border: 1px solid #cdcdcd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-button.more-filters-btn {\n  --background: rgba(174, 15, 10, 1);\n  --color: white;\n  --border-radius: 10px;\n  width: 100%;\n  max-width: 15rem;\n  text-transform: capitalize;\n  font-size: 0.9rem;\n  height: 100%;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\nion-item.fast-filters {\n  padding: 0.25rem 0rem;\n}\n\nion-chip.fast-filter-active-primary {\n  background-color: map-get($success-color, 700);\n  color: white;\n}\n\nion-chip.fast-filter-active-secondary {\n  background-color: map-get($danger-color, 500);\n  color: white;\n}\nion-chip.fast-filter-active-primary-contract {\n\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n\n}\n\nion-chip.fast-filter-active-secondary-contract {\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n}\n.more-filters-btn-row {\n  justify-content: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n\n  button {\n    margin: 5px;\n  }\n\n  @media (max-width: 767px) {\n    button {\n      margin: 5px 0;\n    }\n  }\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n\n  .mat-icon {\n    width: 1rem;\n  }\n\n  .status-icon {\n    font-size: 8px;\n    align-content: center;\n    text-align: center;\n  }\n\n  .active {\n    color: map-get($success-color, 700);\n  }\n\n  .inactive {\n    color: map-get($danger-color, 500);\n  }\n}\n\nion-textarea,\nion-input {\n  --border-color: rgba(87, 87, 86, 1);\n  --padding-top: 5px !important;\n  --highlight-color: rgba(135, 135, 135, 1);\n  --highlight-color-focused: rgba(135, 135, 135, 1) !important;\n  --highlight-color-valid: rgba(135, 135, 135, 1) !important;\n  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;\n}\n\nion-alert.custom-alert {\n  --backdrop-opacity: 0.7;\n}\n\nion-list.filtered-list {\n  display: flex;\n  flex-wrap: wrap;\n\n  span {\n    padding: 0.75rem 0;\n    margin: 0 0.75rem;\n    border-bottom: 1px solid map-get($light-color, 700);\n    width: 100%;\n  }\n}\n\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\n// Toast\nion-toast.snackbar-toast {\n  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  --width: fit-content;\n  --border-radius: 0.75rem;\n  --white-space: pre-line;\n}\n\nion-toast.snackbar-toast {\n  &::part(container) {\n    background: #fff;\n    color: rgba(34, 36, 40, 1);\n    width: fit-content;\n    border-radius: 0.75rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-success {\n  &::part(container) {\n    border: 1px solid rgba(45, 211, 111, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(45, 211, 111, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-error {\n  &::part(container) {\n    border: 1px solid rgba(235, 68, 90, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(235, 68, 90, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-right {\n  --start: right;\n  --box-shadow: none;\n  --background: none;\n\n  &::part(container) {\n    transform: translateY(72px) !important;\n    box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  }\n}\n\n::ng-deep.mat-tab-label {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n/* Styles for the active tab label */\n::ng-deep.mat-tab-label.mat-tab-label-active {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab\n  .mdc-tab-indicator__content--underline {\n  border-color: #2b2b2b;\n}\n\n// .mat-mdc-tab .mdc-tab-indicator__content--underline {\n//   border-color: #2b2b2b;\n// }\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active\n  .mdc-tab__text-label {\n  color: #2b2b2b;\n}\n\n.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {\n      box-shadow: none !important;\n}\n.g-bubble {\n  box-shadow: none !important;\n}\napp-modal-historic-segment {\n  display: block;\n  width: 100%;\n  height: 45em;\n}\n\n.column-flex {\n  display: flex;\n  flex-flow: column;\n}\n\n.master-icon {\n  background-color: map-get($warning-color, 300);\n  color: map-get($dark-color, 500);\n  border-radius: 10px;\n  align-self: flex-start;\n  font-size: 10px;\n  padding: 0px 9px;\n  margin: 6px 0;\n  line-height: 17px;\n  font-weight: 600;\n\n  &.center-horizontal {\n    place-self: center;\n  }\n}\n\nion-popover {\n  --min-width: 375px;\n  --max-width: 500px;\n}\n.custom-tooltip-menu {\n  padding: 8px;\n  \n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n\n  .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n    background: none;\n  }\n  .mdc-evolution-chip__text-label {\n    color: #c00;\n  }\n}\n\n.custom-tooltip-menu .filter-title {\n  font-size: 12px;\n  font-weight: bold;\n  color: #333;\n  display: block;\n  margin-bottom: 4px;\n  border-bottom: 1px solid grey;\n}\n\n.custom-tooltip-menu .tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.custom-tooltip-menu mat-chip {\n  border: 1px solid #c00;\n  height: 20px;\n}\n\n.custom-tooltip-menu mat-chip mat-icon {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 14px !important;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 0px !important;\n}\n.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 12px !important;\n  opacity: 1;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline  {\n  border: 1px solid #c00 !important;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {\n  color: #c00 !important;\n}\nion-toggle {\n  --handle-background-checked: rgba(174, 15, 10, 1);\n  --track-background-checked: rgba(174, 15, 10, 0.38);\n}\napp-list-contracts {\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\napp-table-default{\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\n.mat-expansion-panel-body{\n  padding: 0px !important;\n}\n.mat-mdc-paginator-range-actions {\n \n  overflow-wrap: anywhere !important;\n  flex-grow: 1;\n  justify-content: center !important;\n  position: relative !important;\n}\n.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {\n  position: absolute !important;\n  left: 0 !important;\n}\n.mat-mdc-tab{\n  background-color: #F4F4F4 !important;\n}\n.mdc-tab--active{\n  background-color: white !important;\n}\n#paginator{\n  @media(max-width: 1025px){\n    width: 100%;\n  }\n\n}\nion-icon.search-icon-absolute {\n  position: absolute;\n  left: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 3;\n}\n\nion-input.search-input {\n  label.input-wrapper {\n    --padding-start: 55px;\n  }\n\n  &.has-focus,\n  &.has-value {\n    .input-wrapper {\n      .label-text-wrapper {\n      }\n    }\n  }\n}\n.mat-mdc-icon-button[disabled] {\n    cursor: default;\n        pointer-events: auto;\n    opacity: .38;\n}\n.mat-mdc-unelevated-button[disabled] {\n    cursor: default;\n      pointer-events: auto;\n    opacity: .38;\n}\n\n.item-inner{\n  padding-right: 0 !important;\n}\n\n.mat-mdc-paginator-page-size-label {\n  @media (max-width: 496px) {\n    display: none !important;\n  }\n}\n.comentarios .mdc-text-field--outlined {\n  --mdc-outlined-text-field-outline-width: 1px;\n  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */\n  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */\n  --mdc-outlined-text-field-container-shape: 4px;\n}\n// Gaps gerais\n.g-0 { gap: 0 !important; }\n.g-1 { gap: 0.25rem !important; }\n.g-2 { gap: 0.5rem !important; }\n.g-3 { gap: 1rem !important; }\n.g-4 { gap: 1.5rem !important; }\n.g-5 { gap: 3rem !important; }\n\n// Gaps horizontais\n.gx-0 { column-gap: 0 !important; }\n.gx-1 { column-gap: 0.25rem !important; }\n.gx-2 { column-gap: 0.5rem !important; }\n.gx-3 { column-gap: 1rem !important; }\n.gx-4 { column-gap: 1.5rem !important; }\n.gx-5 { column-gap: 3rem !important; }\n\n// Gaps verticais\n.gy-0 { row-gap: 0 !important; }\n.gy-1 { row-gap: 0.25rem !important; }\n.gy-2 { row-gap: 0.5rem !important; }\n.gy-3 { row-gap: 1rem !important; }\n.gy-4 { row-gap: 1.5rem !important; }\n.gy-5 { row-gap: 3rem !important; }\n.col {\n  flex: 1 0 0%;\n  max-width: 100%;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.col-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n.col-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n.col-3 { flex: 0 0 23%; max-width: 23%; }\n.col-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n.col-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n.col-6 { flex: 0 0 48%; max-width: 48%; }\n.col-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n.col-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n.col-9 { flex: 0 0 73%; max-width: 73%; }\n.col-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n.col-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n.col-12 { flex: 0 0 98%; max-width: 98%; }\n\n/* Colunas responsivas */\n@media (min-width: 576px) { /* sm */\n  .col-sm-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-sm-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-sm-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-sm-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-sm-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-sm-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-sm-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-sm-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-sm-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-sm-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-sm-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-sm-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 768px) { /* md */\n  .col-md-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-md-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-md-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-md-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-md-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-md-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-md-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-md-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-md-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-md-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-md-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-md-12 { flex: 0 0 100%; max-width: 100%; }\n}\n\n@media (min-width: 992px) { /* lg */\n  .col-lg-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-lg-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-lg-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-lg-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-lg-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-lg-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-lg-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-lg-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-lg-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-lg-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-lg-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-lg-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1200px) { /* xl */\n  .col-xl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1400px) { /* xxl */\n  .col-xxl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xxl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xxl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xxl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xxl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xxl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xxl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xxl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xxl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xxl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xxl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xxl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n.ampliacao-panel{\n  max-width: 60vw !important;\n}\n.popover-content{\n  max-height: 150px;\n}\napp-form-projetos thead tr th{\n    font-family: \"Barlow\", sans-serif !important;\n    font-weight: 500 !important;\n    font-size: 18px !important;\n    line-height: 100% !important;\n  \n}\napp-form-projetos .mat-mdc-header-cell{\n    border: none !important;\n  \n}\napp-form-projetos .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n}\n\n.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background\n {\n    border-color: #AE0F0A !important;\n    background-color: #AE0F0A !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
